import { shopManagerApi } from 'configs';
import api from 'configs/api';
import {
  getStoreBrandsStart,
  getStoreBrandsSuccess,
  getStoreBrandsFailed,
  getAllBrandsStart,
  getAllBrandsSuccess,
  getAllBrandsFailed,
} from 'redux/actions/brands';
import {
  getStoreEmailsStart,
  getStoreEmailsSuccess,
  getStoreEmailsFailed,
  updateStoreEmailsStart,
  updateStoreEmailsSuccess,
  updateStoreEmailsFailed
} from 'redux/actions/store_emails';
import {
  showNotification
} from 'redux/actions/ui';
import {
  getEditableStoreProductStart,
  getEditableStoreProductSuccess,
  getEditableStoreProductFailed,
  addProductToStoreStart,
  addProductToStoreSuccess,
  addProductToStoreFailed,
  getStoreProductsStart,
  getStoreProductsSuccess,
  getStoreProductsFailed,
  saveStoreProductMediaGalleryStart,
  saveStoreProductMediaGallerySuccess,
  saveStoreProductMediaGalleryFailed,
  getProductSubscriptionOptionsSuccess,
  addSubscriptionOptionStart,
  addProductSubscriptionOptionSuccess,
  addSubscriptionOptionFailed,
  editProductSubscriptionOptionStart,
  editProductSubscriptionOptionSuccess,
  deleteProductSubscriptionOptionSuccess,
  editProductSubscriptionOptionFailed,
  saveStoreProductSubscriptionAttrStart,
  saveStoreProductSubscriptionAttrSuccess,
  saveStoreProductSubscriptionAttrFailed,
  deleteProductSubscriptionOptionFailed,
  deleteOneTimeSubscriptionOptionStart,
  deleteOneTimeSubscriptionOptionSuccess,
  deleteOneTimeSubscriptionOptionFailed,
  getProductCustomOptionsSuccess,
  deleteCustomOptionStart,
  deleteCustomOptionSuccess,
  deleteCustomOptionFailed,
  deleteCustomOptionValueStart,
  deleteCustomOptionValueFailed,
  editCustomOptionStart,
  editCustomOptionSuccess,
  editCustomOptionFailed,
  deleteCustomOptionValueSuccess,
  getCustomOptionByIdSuccess,
  getCustomOptionByIdStart,
  getCustomOptionByIdFailed,
  getCustomOptionsPriceTypesStart,
  getCustomOptionsPriceTypesSuccess,
  getCustomOptionsPriceTypesFailed,
  saveCustomOptionsPriceTypesStart,
  saveCustomOptionsPriceTypesSuccess,
  saveCustomOptionsPriceTypesFailed,
  editStoreProductStart,
  editStoreProductSuccess,
  editStoreProductFailed,
  deleteStoreProductStart,
  deleteStoreProductSuccess,
  deleteStoreProductFailed,
  saveOneTimePurchaseProductAttrStart,
  saveOneTimePurchaseProductAttrSuccess,
  saveOneTimePurchaseProductAttrFailed,
  getCategoryProductsSuccess,
  getCategoryProductsStart,
  getCategoryProductsFailed,
  addCustomOptionStart,
  addCustomOptionFailed,
  addCustomOptionSuccess,
  saveStoreProductsByCategoryStart,
  saveStoreProductsByCategorySuccess,
  saveStoreProductsByCategoryFailed,
  saveStoreProductCategoriesStart,
  saveStoreProductCategoriesSuccess,
  saveStoreProductCategoriesFailed,
  getFBTLinksStart,
  getFBTLinksSuccess,
  getFBTLinksFailed,
  saveFBTLinksStart,
  saveFBTLinksSuccess,
  saveFBTLinksFailed,
  saveFBTLinksWarning,
  removeFBTLinkStart,
  removeFBTLinkSuccess,
  removeFBTLinkFailed,
  getStoreProductsExportStart,
  getStoreProductsExportSuccess,
  getStoreProductsExportFailed,
  editStoreProductUpSellStart,
  editStoreProductUpSellSuccess,
  editStoreProductUpSellFailed,
  removeStoreProductRelatedLinksStart,
  removeStoreProductRelatedLinksSuccess,
  removeStoreProductRelatedLinksFailed,
  editStoreProductCrossSellStart,
  editStoreProductCrossSellSuccess,
  editStoreProductCrossSellFailed,
  getStoreTaxClassesStart,
  getStoreTaxClassesSuccess,
  getStoreTaxClassesFailed,
  getAllTasksFromQueueStart,
  getAllTasksFromQueueSuccess,
  getAllTasksFromQueueFailed,
  addTasksToQueueStart,
  addTasksToQueueSuccess,
  addTasksToQueueFailed,
  removeTaskFromQueueStart,
  removeTaskFromQueueSuccess,
  removeTaskFromQueueFailed,
  addPatientCertificationStart,
  addPatientCertificationFailed,
  addPatientCertificationSuccess,
  editPatientCertificationsStart,
  editPatientCertificationsSuccess,
  editPatientCertificationsFailed,
  setPatientCertificationStart,
  setPatientCertificationSuccess,
  setPatientCertificationFailed,
  deletePatientCertificationStart,
  deletePatientCertificationSuccess,
  deletePatientCertificationsFailed,
} from 'redux/actions/products';
import {
  getStoreCategoriesStart,
  getStoreCategoriesSuccess,
  getStoreCategoriesFailed,
  getStoreCategoriesTreeStart,
  getStoreCategoriesTreeSuccess,
  getStoreCategoriesTreeFailed,
  saveStoreCategoryStart,
  saveStoreCategorySuccess,
  saveStoreCategoryFailed,
  createStoreCategoryStart,
  createStoreCategorySuccess,
  createStoreCategoryFailed
} from 'redux/actions/categories';
import {
  getStoreConfigsStart,
  getStoreConfigsSuccess,
  getStoreConfigsFailed,
  updateStoreConfigsStart,
  updateStoreConfigsSuccess,
  updateStoreConfigsFailed,
  updateStoreSiteMapStart,
  updateStoreSiteMapSuccess,
  updateStoreSiteMapFailed,
  getRewardBehaviorRulesStart,
  getRewardBehaviorRulesSuccess,
  getRewardBehaviorRulesFailed,
  saveNotificationOptionsStart,
  saveNotificationOptionsSuccess,
  saveNotificationOptionsWarning,
  saveNotificationOptionsFailed,
  updateRewardBehaviorRuleStart,
  updateRewardBehaviorRuleSuccess,
  updateRewardBehaviorRuleFailed,
  getFollowUpEmailsStart,
  getFollowUpEmailsSuccess,
  getFollowUpEmailsFailed,
  getSocialMediaConfigsStart,
  getSocialMediaConfigsSuccess,
  getSocialMediaConfigsFailed,
  saveSocialMediaConfigsStart,
  saveSocialMediaConfigsSuccess,
  saveSocialMediaConfigsFailed,
  getSurveyQuestionConfigsStart,
  getSurveyQuestionConfigsSuccess,
  getSurveyQuestionConfigsFailed,
  getHomepagePromoCategoriesConfigsStart,
  getHomepagePromoCategoriesConfigsSuccess,
  getHomepagePromoCategoriesConfigsFailed,
  getHomepageWelcomeBlockConfigsStart,
  getHomepageWelcomeBlockConfigsSuccess,
  getHomepageWelcomeBlockConfigsFailed,
  saveHomepageWelcomeBlockConfigsStart,
  saveHomepageWelcomeBlockConfigsSuccess,
  saveHomepageWelcomeBlockConfigsFailed,
  getHomepageInstagramBlockConfigsStart,
  getHomepageInstagramBlockConfigsSuccess,
  getHomepageInstagramBlockConfigsFailed,
  saveHomepageInstagramBlockConfigsStart,
  saveHomepageInstagramBlockConfigsSuccess,
  saveHomepageInstagramBlockConfigsFailed,
  getHomepageBenefitsBlockConfigsStart,
  getHomepageBenefitsBlockConfigsSuccess,
  getHomepageBenefitsBlockConfigsFailed,
  saveHomepageBenefitsBlockConfigsStart,
  saveHomepageBenefitsBlockConfigsSuccess,
  saveHomepageBenefitsBlockConfigsFailed,
  getHomepageCTABlockConfigsStart,
  getHomepageCTABlockConfigsSuccess,
  getHomepageCTABlockConfigsFailed,
  saveHomepageCTABlockConfigsStart,
  saveHomepageCTABlockConfigsSuccess,
  saveHomepageCTABlockConfigsFailed,
  getHomepageBlogBlockConfigsStart,
  getHomepageBlogBlockConfigsSuccess,
  getHomepageBlogBlockConfigsFailed,
  saveHomepageBlogBlockConfigsStart,
  saveHomepageBlogBlockConfigsSuccess,
  saveHomepageBlogBlockConfigsFailed,
  getHomepagePremiumCTAConfigsStart,
  getHomepagePremiumCTAConfigsSuccess,
  getHomepagePremiumCTAConfigsFailed,
  saveHomepagePremiumCTAConfigsStart,
  saveHomepagePremiumCTAConfigsSuccess,
  saveHomepagePremiumCTAConfigsFailed,
  getHomepageAdditionalBannersConfigsStart,
  getHomepageAdditionalBannersConfigsSuccess,
  getHomepageAdditionalBannersConfigsFailed,
  saveHomepageAdditionalBannersConfigsStart,
  saveHomepageAdditionalBannersConfigsSuccess,
  saveHomepageAdditionalBannersConfigsFailed,
  getHomepageAdditionalHeaderConfigsStart,
  getHomepageAdditionalHeaderConfigsSuccess,
  getHomepageAdditionalHeaderConfigsFailed,
  saveHomepageAdditionalHeaderConfigsStart,
  saveHomepageAdditionalHeaderConfigsSuccess,
  saveHomepageAdditionalHeaderConfigsFailed,
  getHomepageTestimonialsConfigsStart,
  getHomepageTestimonialsConfigsSuccess,
  getHomepageTestimonialsConfigsFailed,
  saveHomepageTestimonialsConfigsStart,
  saveHomepageTestimonialsConfigsSuccess,
  saveHomepageTestimonialsConfigsFailed,
  getHomepageRewardBlockConfigsStart,
  getHomepageRewardBlockConfigsSuccess,
  getHomepageRewardBlockConfigsFailed,
  saveHomepageRewardBlockConfigsStart,
  saveHomepageRewardBlockConfigsSuccess,
  saveHomepageRewardBlockConfigsFailed,
  getAppointmentBlockConfigsStart,
  getAppointmentBlockConfigsSuccess,
  getAppointmentBlockConfigsFailed,
  saveAppointmentBlockConfigsStart,
  saveAppointmentBlockConfigsSuccess,
  saveAppointmentBlockConfigsFailed,
  getAboutUsPageConfigsStart,
  getAboutUsPageConfigsSuccess,
  getAboutUsPageConfigsFailed,
  saveAboutUsPageConfigsStart,
  saveAboutUsPageConfigsSuccess,
  saveAboutUsPageConfigsFailed,
  getBeforeAfterGalleryConfigsStart,
  getBeforeAfterGalleryConfigsSuccess,
  getBeforeAfterGalleryConfigsFailed,
  saveBeforeAfterGalleryConfigsStart,
  saveBeforeAfterGalleryConfigsSuccess,
  saveBeforeAfterGalleryConfigsFailed,
  getStoreContactsConfigsStart,
  getStoreContactsConfigsSuccess,
  getStoreContactsConfigsFailed,
  saveStoreContactsConfigsStart,
  saveStoreContactsConfigsSuccess,
  saveStoreContactsConfigsFailed,
  getStoreEmailsConfigsStart,
  getStoreEmailsConfigsSuccess,
  getStoreEmailsConfigsFailed,
  createMerchantAccountStart,
  createMerchantAccountSuccess,
  createMerchantAccountFailed,
  getStoreConfigsSummaryStart,
  getStoreConfigsSummarySuccess,
  getStoreConfigsSummaryFailed,
  getStoreEmailsStyleStart,
  getStoreEmailsStyleSuccess,
  getStoreEmailsStyleFailed,
  saveStoreNameStart,
  saveStoreNameSuccess,
  saveStoreNameFailed,
  getPaymentIntegrationsStart,
  getPaymentIntegrationsSuccess,
  getPaymentIntegrationsFailed,
  getStoreEmailsConfigsDataStart,
  getStoreEmailsConfigsDataSuccess,
  getStoreEmailsConfigsDataFailed,
  saveStoreEmailsConfigsDataStart,
  saveStoreEmailsConfigsDataSuccess,
  saveStoreEmailsConfigsDataFailed,
  getRequestAccessConfigsStart,
  getRequestAccessConfigsSuccess,
  getRequestAccessConfigsFailed,
  getDepositConfigStart,
  getDepositConfigSuccess,
  getDepositConfigFailed,
  getSARPUpdateConfigStart,
  getSARPUpdateConfigSuccess,
  getSARPUpdateConfigFailed
} from 'redux/actions/store_configs';
import {
  getStoreEarningRulesStart,
  getStoreEarningRulesSuccess,
  getStoreEarningRulesFailed,
  getStoreSpendingRulesStart,
  getStoreSpendingRulesSuccess,
  getStoreSpendingRulesFailed,
  saveEarningRulesStart,
  saveEarningRulesSuccess,
  saveEarningRulesFailed,
  saveSpendingRulesStart,
  saveSpendingRulesSuccess,
  saveSpendingRulesFailed,
  getStoreRewardBehaviourRulesStart,
  getStoreRewardBehaviourRulesSuccess,
  getStoreRewardBehaviourRulesFailed,
  saveStoreRewardBehaviourRulesStart,
  saveStoreRewardBehaviourRulesSuccess,
  saveStoreRewardBehaviourRulesFailed
} from 'redux/actions/marketing_rules';
import {
  getFraudOrdersStart,
  getFraudOrdersSuccess,
  getFraudOrdersFailed,
  updateFraudOrderStatusStart,
  updateFraudOrderStatusSuccess,
  updateFraudOrderStatusFailed
} from 'redux/actions/sales';
import {
  getStorePickupLocationsStart,
  getStorePickupLocationsSuccess,
  getStorePickupLocationsFailed,
  addStorePickupLocationStart,
  addStorePickupLocationSuccess,
  addStorePickupLocationFailed,
  updateStorePickupLocationStart,
  updateStorePickupLocationSuccess,
  updateStorePickupLocationFailed,
  deleteStorePickupLocationStart,
  deleteStorePickupLocationSuccess,
  deleteStorePickupLocationFailed,
  getStorePickupConfigStart,
  getStorePickupConfigSuccess,
  getStorePickupConfigFailed,
  updateStorePickupConfigStart,
  updateStorePickupConfigSuccess,
  updateStorePickupConfigFailed
} from 'redux/actions/store_pickup';
import {
  getCouponListStart,
  getCouponListSuccess,
  getCouponListFailed,
  generateCouponForEmailStart,
  generateCouponForEmailSuccess,
  generateCouponForEmailFailed,
  generateCouponRuleStart,
  generateCouponRuleSuccess,
  generateCouponRuleFailed,
  updateCouponRuleCombinedStart,
  updateCouponRuleCombinedSuccess,
  updateCouponRuleCombinedFailed,
  createCouponRuleCombinedStart,
  createCouponRuleCombinedSuccess,
  createCouponRuleCombinedFailed,
  getCouponRulesStart,
  getCouponRulesSuccess,
  getCouponRulesFailed,
  getCouponCodeStart,
  getCouponCodeSuccess,
  getCouponCodeFailed,
  deleteCouponRuleStart,
  deleteCouponRuleSuccess,
  deleteCouponRuleFailed,
} from 'redux/actions/coupon_rules';
import {
  getCMSPagesStart,
  getCMSPagesSuccess,
  getCMSPagesFailed,
  updateCMSPageStart,
  updateCMSPageSuccess,
  updateCMSPageFailed
} from 'redux/actions/cms_pages';
import {
  getStoreLogosStart,
  getStoreLogosFailed,
  getStoreLogosSuccess,
  getConfigsLogosStart,
  getConfigsLogosSuccess,
  getConfigsLogosFaild,
  uploadStoreLogoStart,
  uploadStoreLogoSuccess,
  uploadStoreLogoFailed,
  setStoreLogoSuccess,
  setConfigLogosSuccess,
  updateAllLogosStart,
  updateAllLogosSuccess,
  updateAllLogosFailed
} from 'redux/actions/general';
import {
  getHomepageBannerGroupStart,
  getHomepageBannerGroupSuccess,
  getHomepageBannerGroupFailed,
  saveBannerSlideStart,
  saveBannerSlideSuccess,
  saveBannerSlideFailed,
  deleteBannerSlideStart,
  deleteBannerSlideSuccess,
  deleteBannerSlideFailed,
  addNewBannerSlideStart,
  addNewBannerSlideSuccess,
  addNewBannerSlideFailed
} from 'redux/actions/banner_manager';
import {
  getReferralRulesStart,
  getReferralRulesSuccess,
  getReferralRulesFailed,
  saveReferralRuleStart,
  saveReferralRuleSuccess,
  saveReferralRuleFaild,
  deleteReferralRuleStart,
  deleteReferralRuleSuccess,
  deleteReferralRuleFailed
} from 'redux/actions/referral_program';
import {
  getCurrentStoreStylesStart,
  getCurrentStoreStylesSuccess,
  getCurrentStoreStylesFailed,
  getDefaultStoreStylesStart,
  getDefaultStoreStylesSuccess,
  getDefaultStoreStylesFailed,
  saveStoreStylesStart,
  saveStoreStylesSuccess,
  saveStoreStylesFailed
} from 'redux/actions/styles_palette';

import {
  sendDNSConfigurationsStart,
  sendDNSConfigurationsSuccess,
  sendDNSConfigurationsFailed,
  verifyDNSConfigurationsStart,
  verifyDNSConfigurationsSuccess,
  verifyDNSConfigurationsFailed
} from 'redux/actions/dns_manager';

import {
  getAppointmentButtonConfigsFailed,
  getAppointmentButtonConfigsStart,
  getAppointmentButtonConfigsSuccess,
  getBookNowButtonConfigFailed,
  getBookNowButtonConfigsStart,
  getBookNowButtonConfigsSuccess,
  saveAppointmentButtonConfigsSuccess,
  saveBookNowButtonConfigFailed,
  saveBookNowButtonConfigStart,
  saveBookNowButtonConfigSuccess,
  saveAppointmentButtonConfigsStart,
  saveAppointmentButtonConfigFailed
} from 'redux/actions/buttons_configs';

import {
  getStoreTaxRatesStart,
  getStoreTaxRatesSuccess,
  getStoreTaxRatesFailed,
  createNewTaxRateStart,
  createNewTaxRateSuccess,
  createNewTaxRateFailed,
  editTaxRateStart,
  editTaxRateSuccess,
  editTaxRateFailed,
  deleteTaxRateStart,
  deleteTaxRateSuccess,
  deleteTaxRateFailed
} from 'redux/actions/tax_rates';

import { serialize, convertToSearchCriteria } from '../helpers/api';


export const getStoreConfigsApi = async ({dispatch}) => {
  try {
    const params = [
      'configs[]=wishlist/general/active',
      'configs[]=catalog/review/allow_guest',
      'configs[]=advanced/modules_disable_output/Magento_Review',
      'configs[]=store_info/tagline/enable',
      'configs[]=store_info/tagline/content',
      'configs[]=store_info/home_tabs/is_carousel_enabled',
      'configs[]=store_info/home_tabs/is_carousel_1_enabled',
      'configs[]=store_info/home_tabs/carousel_1_title',
      'configs[]=store_info/home_tabs/carousel_1_category_id',
      'configs[]=store_info/home_tabs/is_carousel_2_enabled',
      'configs[]=store_info/home_tabs/carousel_2_title',
      'configs[]=store_info/home_tabs/carousel_2_category_id',
      'configs[]=store_info/home_tabs/is_carousel_3_enabled',
      'configs[]=store_info/home_tabs/carousel_3_title',
      'configs[]=store_info/home_tabs/carousel_3_category_id',
      'configs[]=store_info/compare_configuration/is_enable',
      'configs[]=carriers/flatrate/active',
      'configs[]=carriers/flatrate/price',
      'configs[]=carriers/flatrate/title',
      'configs[]=carriers/freeshipping/active',
      'configs[]=carriers/freeshipping/free_shipping_subtotal',
      'configs[]=carriers/freeshipping/title',
      'configs[]=store_info/tagline/enable',
      'configs[]=store_info/tagline/content',
      'configs[]=rewardpoints/general/enabled',
      'configs[]=rewardpoints/referrals/enabled',
      'configs[]=customer/recaptcha/enabled',
      'configs[]=customer/recaptcha/site_key',
      'configs[]=customer/recaptcha/secret_key',
      'configs[]=customer/recaptcha/forms',
      'configs[]=customer/address/dob_show',
      'configs[]=customer/address/gender_show',
      'configs[]=subscriptions/general/enable_first_free_shipping_total'
    ];

    dispatch(getStoreConfigsStart());
    const {data} = await api.get(`${shopManagerApi}/store/configs?${params.join('&')}`);
    dispatch(getStoreConfigsSuccess(data));
  } catch (e) {
    dispatch(getStoreConfigsFailed(e));
  }
};

export const getSocialMediaConfigsApi = async ({dispatch}) => {
  try {
    const params = [
      'configs[]=storeautomation/general/facebook_url',
      'configs[]=storeautomation/general/youtube_url',
      'configs[]=storeautomation/general/pinterest_url',
      'configs[]=storeautomation/general/linkedin_url',
      'configs[]=storeautomation/general/instagram_url',
      'configs[]=storeautomation/general/yelp_url',
      'configs[]=storeautomation/general/blog_url',
      'configs[]=storeautomation/general/twitter_url',
      'configs[]=storeautomation/general/realself_url',
      'configs[]=storeautomation/general/rss_url',
      'configs[]=storeautomation/general/snapchat_url',
      'configs[]=storeautomation/general/tiktok_url'
    ];

    dispatch(getSocialMediaConfigsStart());
    const {data} = await api.get(`${shopManagerApi}/store/configs?${params.join('&')}`);
    dispatch(getSocialMediaConfigsSuccess(data));
  } catch (e) {
    dispatch(getSocialMediaConfigsFailed(e));
  }
};

export const getSurveyQuestionConfigsApi = async ({dispatch}) => {
  try {
    const params = [
      'configs[]=surveyquestion/general/enable',
      'configs[]=surveyquestion/general/surveyquestion',
      'configs[]=surveyquestion/general/surveyvalues'
    ];

    dispatch(getSurveyQuestionConfigsStart());
    const {data} = await api.get(`${shopManagerApi}/store/configs?${params.join('&')}`);
    dispatch(getSurveyQuestionConfigsSuccess(data));
  } catch (e) {
    dispatch(getSurveyQuestionConfigsFailed(e));
  }
};

export const getStoreEmailsConfigsApi = async ({dispatch}) => {
  try {
    const params = [
      'configs[]=rewardpoints/email/enable',
      'configs[]=rewardpoints/email/update/enabled',
      'configs[]=rewardpoints/email/expire/enabled',
      'configs[]=mpgiftcard/email/enable',
      'configs[]=mpgiftcard/email/update/enable',
      'configs[]=mpgiftcard/email/before_expire/enable',
      'configs[]=mpgiftcard/email/notify_sender/enable',
      'configs[]=mpgiftcard/email/after_unused/enable',
      'configs[]=mpgiftcard/email/credit/enable',
      'configs[]=mpgiftcard/sms/enable',
      'configs[]=subscriptions/billing_failed/active',
      'configs[]=subscriptions/payment_failed/active',
      'configs[]=subscriptions/billing_notice/active',
      'configs[]=subscriptions/subscription_expiration/active',
      'configs[]=subscriptions/subscription_suspension/active',
      'configs[]=subscriptions/subscription_reactivation/active',
      'configs[]=subscriptions/subscription_confirm/active',
      'configs[]=subscriptions/subscription_cancel/active',
      'configs[]=subscriptions/subscription_skip/active',
      'configs[]=subscriptions/subscription_available_product/active',
      'configs[]=sales_email/order/enabled',
      'configs[]=sales_email/order_comment/enabled',
      'configs[]=sales_email/invoice/enabled',
      'configs[]=sales_email/invoice_comment/enabled',
      'configs[]=sales_email/shipment/enabled',
      'configs[]=sales_email/shipment_comment/enabled',
      'configs[]=sales_email/creditmemo/enabled',
      'configs[]=sales_email/creditmemo_comment/enabled',
      'configs[]=customer/create_account/confirm',
      'configs[]=sendfriend/email/enabled',
      'configs[]=dermpro_maxmind_config/general/send_email'
    ];

    dispatch(getStoreEmailsConfigsStart());
    const {data} = await api.get(`${shopManagerApi}/store/configs?${params.join('&')}`);
    dispatch(getStoreEmailsConfigsSuccess(data));
  } catch (e) {
    dispatch(getStoreEmailsConfigsFailed(e));
  }
};

export const getHomepagePromoCategoriesConfigsApi = async ({dispatch}) => {
  try {
    const params = [
      'configs[]=store_info/home_tabs/is_carousel_enabled',
      'configs[]=store_info/home_tabs/is_carousel_1_enabled',
      'configs[]=store_info/home_tabs/carousel_1_title',
      'configs[]=store_info/home_tabs/carousel_1_category_id',
      'configs[]=store_info/home_tabs/is_button_1_enabled',
      'configs[]=store_info/home_tabs/button_1_title',
      'configs[]=store_info/home_tabs/button_1_category_id',
      'configs[]=store_info/home_tabs/is_carousel_2_enabled',
      'configs[]=store_info/home_tabs/carousel_2_title',
      'configs[]=store_info/home_tabs/carousel_2_category_id',
      'configs[]=store_info/home_tabs/is_button_2_enabled',
      'configs[]=store_info/home_tabs/button_2_title',
      'configs[]=store_info/home_tabs/button_2_category_id',
      'configs[]=store_info/home_tabs/is_carousel_3_enabled',
      'configs[]=store_info/home_tabs/carousel_3_title',
      'configs[]=store_info/home_tabs/carousel_3_category_id',
      'configs[]=store_info/home_tabs/is_button_3_enabled',
      'configs[]=store_info/home_tabs/button_3_title',
      'configs[]=store_info/home_tabs/button_3_category_id'
    ];

    dispatch(getHomepagePromoCategoriesConfigsStart());
    const {data} = await api.get(`${shopManagerApi}/store/configs?${params.join('&')}`);
    dispatch(getHomepagePromoCategoriesConfigsSuccess(data));
  } catch (e) {
    dispatch(getHomepagePromoCategoriesConfigsFailed(e));
  }
};

export const getHomepageWelcomeBlockConfigsApi = async ({dispatch}) => {
  try {
    const params = [
      'configs[]=store_info/welcome/is_welcome_block_enabled',
      'configs[]=store_info/welcome/welcome_block_heading',
      'configs[]=store_info/welcome/welcome_block_content',
      'configs[]=store_info/welcome/welcome_block_above_heading'
    ];

    dispatch(getHomepageWelcomeBlockConfigsStart());
    const {data} = await api.get(`${shopManagerApi}/store/configs?${params.join('&')}`);
    dispatch(getHomepageWelcomeBlockConfigsSuccess(data));
  } catch (e) {
    dispatch(getHomepageWelcomeBlockConfigsFailed(e));
  }
};

export const getSARPUpdateConfigApi = async ({dispatch}) => {
  try {
    dispatch(getSARPUpdateConfigStart());
    const {data} = await api.get(`${shopManagerApi}/store/configs?configs[]=subscriptions/general/update_sarp_after_product`);
    dispatch(getSARPUpdateConfigSuccess(data));
  } catch (e) {
    dispatch(getSARPUpdateConfigFailed(e));
  }
};

export const saveHomepageWelcomeBlockConfigsApi = async ({dispatch, configs}) => {
  try {
    dispatch(saveHomepageWelcomeBlockConfigsStart());
    const {data} = await api.patch(`${shopManagerApi}/store/configs`, {configs});
    dispatch(saveHomepageWelcomeBlockConfigsSuccess(data));
  } catch (e) {
    dispatch(saveHomepageWelcomeBlockConfigsFailed(e));
  }
};

export const getHomepageInstagramBlockConfigsApi = async ({dispatch}) => {
  try {
    const params = [
      'configs[]=store_info/instagram/is_instagram_block_enabled',
      'configs[]=store_info/instagram/instagram_block_name',
      'configs[]=store_info/instagram/instagram_block_link',
      'configs[]=store_info/instagram/instagram_block_script',
      'configs[]=store_info/instagram/instagram_block_button_title'
    ];

    dispatch(getHomepageInstagramBlockConfigsStart());
    const {data} = await api.get(`${shopManagerApi}/store/configs?${params.join('&')}`);
    dispatch(getHomepageInstagramBlockConfigsSuccess(data));
  } catch (e) {
    dispatch(getHomepageInstagramBlockConfigsFailed(e));
  }
};

export const saveHomepageInstagramBlockConfigsApi = async ({dispatch, configs}) => {
  try {
    dispatch(saveHomepageInstagramBlockConfigsStart());
    const {data} = await api.patch(`${shopManagerApi}/store/configs`, {configs});
    dispatch(saveHomepageInstagramBlockConfigsSuccess(data));
  } catch (e) {
    dispatch(saveHomepageInstagramBlockConfigsFailed(e));
  }
};

export const getHomepageBenefitsBlockConfigsApi = async ({dispatch}) => {
  try {
    const params = [
      'configs[]=store_info/benefits/is_enable',
      'configs[]=store_info/benefits/is_free_shipping_enabled',
      'configs[]=store_info/benefits/is_rewards_enabled',
      'configs[]=store_info/benefits/is_customer_service_enabled'
    ];

    dispatch(getHomepageBenefitsBlockConfigsStart());
    const {data} = await api.get(`${shopManagerApi}/store/configs?${params.join('&')}`);
    dispatch(getHomepageBenefitsBlockConfigsSuccess(data));
  } catch (e) {
    dispatch(getHomepageBenefitsBlockConfigsFailed(e));
  }
};

export const saveHomepageBenefitsBlockConfigsApi = async ({dispatch, configs}) => {
  try {
    dispatch(saveHomepageBenefitsBlockConfigsStart());
    const {data} = await api.patch(`${shopManagerApi}/store/configs`, {configs});
    dispatch(saveHomepageBenefitsBlockConfigsSuccess(data));
  } catch (e) {
    dispatch(saveHomepageBenefitsBlockConfigsFailed(e));
  }
};

export const getHomepageCTABlockConfigsApi = async ({dispatch}) => {
  try {
    const params = [
      'configs[]=store_info/cta/is_cta_enabled',
      'configs[]=store_info/cta/cta_vertical_title',
      'configs[]=store_info/cta/cta_horizontal_top_title',
      'configs[]=store_info/cta/cta_horizontal_bottom_title',
      'configs[]=store_info/cta/cta_vertical_mask_title',
      'configs[]=store_info/cta/cta_horizontal_top_mask_title',
      'configs[]=store_info/cta/cta_horizontal_bottom_mask_title',
      'configs[]=store_info/cta/is_cta_vertical_mask_category_1',
      'configs[]=store_info/cta/is_cta_vertical_mask_category_2',
      'configs[]=store_info/cta/is_cta_vertical_mask_category_3',
      'configs[]=store_info/cta/is_cta_vertical_mask_category_4',
      'configs[]=store_info/cta/is_cta_vertical_mask_category_5',
      'configs[]=store_info/cta/is_cta_vertical_mask_category_6',
      'configs[]=store_info/cta/cta_vertical_mask_categoryId_1',
      'configs[]=store_info/cta/cta_vertical_mask_categoryId_2',
      'configs[]=store_info/cta/cta_vertical_mask_categoryId_3',
      'configs[]=store_info/cta/cta_vertical_mask_categoryId_4',
      'configs[]=store_info/cta/cta_vertical_mask_categoryId_5',
      'configs[]=store_info/cta/cta_vertical_mask_categoryId_6',
      'configs[]=store_info/cta/cta_vertical_mask_custom_link_title_1',
      'configs[]=store_info/cta/cta_vertical_mask_custom_link_title_2',
      'configs[]=store_info/cta/cta_vertical_mask_custom_link_title_3',
      'configs[]=store_info/cta/cta_vertical_mask_custom_link_title_4',
      'configs[]=store_info/cta/cta_vertical_mask_custom_link_title_5',
      'configs[]=store_info/cta/cta_vertical_mask_custom_link_title_6',
      'configs[]=store_info/cta/cta_vertical_mask_custom_link_1',
      'configs[]=store_info/cta/cta_vertical_mask_custom_link_2',
      'configs[]=store_info/cta/cta_vertical_mask_custom_link_3',
      'configs[]=store_info/cta/cta_vertical_mask_custom_link_4',
      'configs[]=store_info/cta/cta_vertical_mask_custom_link_5',
      'configs[]=store_info/cta/cta_vertical_mask_custom_link_6',
      'configs[]=store_info/cta/is_cta_horizontal_top_mask_category_1',
      'configs[]=store_info/cta/is_cta_horizontal_top_mask_category_2',
      'configs[]=store_info/cta/is_cta_horizontal_top_mask_category_3',
      'configs[]=store_info/cta/is_cta_horizontal_top_mask_category_4',
      'configs[]=store_info/cta/cta_horizontal_top_mask_categoryId_1',
      'configs[]=store_info/cta/cta_horizontal_top_mask_categoryId_2',
      'configs[]=store_info/cta/cta_horizontal_top_mask_categoryId_3',
      'configs[]=store_info/cta/cta_horizontal_top_mask_categoryId_4',
      'configs[]=store_info/cta/cta_horizontal_top_mask_custom_link_title_1',
      'configs[]=store_info/cta/cta_horizontal_top_mask_custom_link_title_2',
      'configs[]=store_info/cta/cta_horizontal_top_mask_custom_link_title_3',
      'configs[]=store_info/cta/cta_horizontal_top_mask_custom_link_title_4',
      'configs[]=store_info/cta/cta_horizontal_top_mask_custom_link_1',
      'configs[]=store_info/cta/cta_horizontal_top_mask_custom_link_2',
      'configs[]=store_info/cta/cta_horizontal_top_mask_custom_link_3',
      'configs[]=store_info/cta/cta_horizontal_top_mask_custom_link_4',
      'configs[]=store_info/cta/is_cta_horizontal_bottom_mask_category_1',
      'configs[]=store_info/cta/is_cta_horizontal_bottom_mask_category_2',
      'configs[]=store_info/cta/is_cta_horizontal_bottom_mask_category_3',
      'configs[]=store_info/cta/is_cta_horizontal_bottom_mask_category_4',
      'configs[]=store_info/cta/cta_horizontal_bottom_mask_categoryId_1',
      'configs[]=store_info/cta/cta_horizontal_bottom_mask_categoryId_2',
      'configs[]=store_info/cta/cta_horizontal_bottom_mask_categoryId_3',
      'configs[]=store_info/cta/cta_horizontal_bottom_mask_categoryId_4',
      'configs[]=store_info/cta/cta_horizontal_bottom_mask_custom_link_title_1',
      'configs[]=store_info/cta/cta_horizontal_bottom_mask_custom_link_title_2',
      'configs[]=store_info/cta/cta_horizontal_bottom_mask_custom_link_title_3',
      'configs[]=store_info/cta/cta_horizontal_bottom_mask_custom_link_title_4',
      'configs[]=store_info/cta/cta_horizontal_bottom_mask_custom_link_1',
      'configs[]=store_info/cta/cta_horizontal_bottom_mask_custom_link_2',
      'configs[]=store_info/cta/cta_horizontal_bottom_mask_custom_link_3',
      'configs[]=store_info/cta/cta_horizontal_bottom_mask_custom_link_4',
      'configs[]=store_info/cta/cta_vertical_mask_button_categoryId',
      'configs[]=store_info/cta/cta_horizontal_top_mask_button_categoryId',
      'configs[]=store_info/cta/cta_horizontal_bottom_mask_button_categoryId',
      'configs[]=dermpro/design/cta_image_1_desktop',
      'configs[]=dermpro/design/cta_image_1_mobile',
      'configs[]=dermpro/design/cta_image_2_desktop',
      'configs[]=dermpro/design/cta_image_2_mobile',
      'configs[]=dermpro/design/cta_image_3_desktop',
      'configs[]=dermpro/design/cta_image_3_mobile',
      'configs[]=dermpro/design/cta_image_1_desktop_lite',
      'configs[]=dermpro/design/cta_image_1_mobile_lite',
      'configs[]=dermpro/design/cta_image_2_desktop_lite',
      'configs[]=dermpro/design/cta_image_2_mobile_lite',
      'configs[]=dermpro/design/cta_image_3_desktop_lite',
      'configs[]=dermpro/design/cta_image_3_mobile_lite',
    ];

    dispatch(getHomepageCTABlockConfigsStart());
    const {data} = await api.get(`${shopManagerApi}/store/configs?${params.join('&')}`);
    dispatch(getHomepageCTABlockConfigsSuccess(data));
  } catch (e) {
    dispatch(getHomepageCTABlockConfigsFailed(e));
  }
};

export const saveHomepageCTABlockConfigsApi = async ({dispatch, configs}) => {
  try {
    dispatch(saveHomepageCTABlockConfigsStart());
    const {data} = await api.patch(`${shopManagerApi}/store/configs`, {configs});
    dispatch(saveHomepageCTABlockConfigsSuccess(data));
  } catch (e) {
    dispatch(saveHomepageCTABlockConfigsFailed(e));
  }
};

export const getHomepageRewardBlockConfigsApi = async ({dispatch}) => {
  try {
    const params = [
      'configs[]=store_info/reward_homepage/is_reward_block_enabled',
      'configs[]=store_info/reward_homepage/reward_block_content',
      'configs[]=dermpro/design/reward_points_desktop'
    ];

    dispatch(getHomepageRewardBlockConfigsStart());
    const {data} = await api.get(`${shopManagerApi}/store/configs?${params.join('&')}`);
    dispatch(getHomepageRewardBlockConfigsSuccess(data));
  } catch (e) {
    dispatch(getHomepageRewardBlockConfigsFailed(e));
  }
};

export const getHomepageAdditionalHeaderConfigsApi = async ({dispatch}) => {
  try {
    const params = [
      'configs[]=store_info/premium_plus_additional_header/is_additional_header_enable',
      'configs[]=store_info/premium_plus_additional_header/additional_header_first_item/additional_header_first_icon',
      'configs[]=store_info/premium_plus_additional_header/additional_header_first_item/additional_header_first_title',
      'configs[]=store_info/premium_plus_additional_header/additional_header_second_item/additional_header_second_icon',
      'configs[]=store_info/premium_plus_additional_header/additional_header_second_item/additional_header_second_title',
      'configs[]=store_info/premium_plus_additional_header/additional_header_third_item/additional_header_third_icon',
      'configs[]=store_info/premium_plus_additional_header/additional_header_third_item/additional_header_third_title',
      'configs[]=store_info/premium_plus_additional_header/additional_header_fourth_item/additional_header_fourth_icon',
      'configs[]=store_info/premium_plus_additional_header/additional_header_fourth_item/additional_header_fourth_title'
    ];

    dispatch(getHomepageAdditionalHeaderConfigsStart());
    const {data} = await api.get(`${shopManagerApi}/store/configs?${params.join('&')}`);
    dispatch(getHomepageAdditionalHeaderConfigsSuccess(data));
  } catch (e) {
    dispatch(getHomepageAdditionalHeaderConfigsFailed(e));
  }
};

export const getHomepageAdditionalBannersConfigsApi = async ({dispatch}) => {
  try {
    const params = [
      'configs[]=store_info/premium_plus_banners/is_premium_plus_first_banner_enabled',
      'configs[]=store_info/premium_plus_banners/is_premium_plus_second_banner_enabled',
      'configs[]=store_info/premium_plus_banners/is_premium_plus_third_banner_enabled'
    ];

    dispatch(getHomepageAdditionalBannersConfigsStart());
    const {data} = await api.get(`${shopManagerApi}/store/configs?${params.join('&')}`);

    dispatch(getHomepageAdditionalBannersConfigsSuccess(data));
  } catch (e) {
    dispatch(getHomepageAdditionalBannersConfigsFailed(e));
  }
};

export const getPaymentIntegrationsApi = async ({dispatch}) => {
  try {
    const params = ['configs[]=nextech/nextech/enable', 'configs[]=modmed/modmed/enable'];

    dispatch(getPaymentIntegrationsStart());
    const {data} = await api.get(`${shopManagerApi}/store/configs?${params.join('&')}`);

    dispatch(getPaymentIntegrationsSuccess(data));
  } catch (e) {
    dispatch(getPaymentIntegrationsFailed(e));
  }
};

export const getHomepageTestimonialsConfigsApi = async ({dispatch}) => {
  try {
    const params = [
      'configs[]=store_info/premium_plus_testimonails/is_testimonails_enabled',
      'configs[]=store_info/premium_plus_testimonails/is_first_testimonail_enabled',
      'configs[]=store_info/premium_plus_testimonails/first_testimonail_rating',
      'configs[]=store_info/premium_plus_testimonails/first_testimonail_content',
      'configs[]=store_info/premium_plus_testimonails/first_testimonail_author',
      'configs[]=store_info/premium_plus_testimonails/is_second_testimonail_enabled',
      'configs[]=store_info/premium_plus_testimonails/second_testimonail_rating',
      'configs[]=store_info/premium_plus_testimonails/second_testimonail_content',
      'configs[]=store_info/premium_plus_testimonails/second_testimonail_author',
      'configs[]=store_info/premium_plus_testimonails/is_third_testimonail_enabled',
      'configs[]=store_info/premium_plus_testimonails/third_testimonail_rating',
      'configs[]=store_info/premium_plus_testimonails/third_testimonail_content',
      'configs[]=store_info/premium_plus_testimonails/third_testimonail_author',
      'configs[]=store_info/premium_plus_testimonails/is_fourth_testimonail_enabled',
      'configs[]=store_info/premium_plus_testimonails/fourth_testimonail_rating',
      'configs[]=store_info/premium_plus_testimonails/fourth_testimonail_content',
      'configs[]=store_info/premium_plus_testimonails/fourth_testimonail_author',
      'configs[]=store_info/premium_plus_testimonails/is_fifth_testimonail_enabled',
      'configs[]=store_info/premium_plus_testimonails/fifth_testimonail_rating',
      'configs[]=store_info/premium_plus_testimonails/fifth_testimonail_content',
      'configs[]=store_info/premium_plus_testimonails/fifth_testimonail_author',
    ];

    dispatch(getHomepageTestimonialsConfigsStart());
    const {data} = await api.get(`${shopManagerApi}/store/configs?${params.join('&')}`);

    dispatch(getHomepageTestimonialsConfigsSuccess(data));
  } catch (e) {
    dispatch(getHomepageTestimonialsConfigsFailed(e));
  }
};

export const getHomepagePremiumCTAConfigsApi = async ({dispatch}) => {
  try {
    const params = [
      'configs[]=store_info/premium_plus_cta/is_premium_plus_cta_enable',
      'configs[]=store_info/premium_plus_cta/premium_plus_cta_main_title',
      'configs[]=store_info/premium_plus_cta/premium_plus_cta_first_item/is_premium_plus_cta_first_enable',
      'configs[]=store_info/premium_plus_cta/premium_plus_cta_first_item/premium_plus_cta_first_item_image',
      'configs[]=store_info/premium_plus_cta/premium_plus_cta_first_item/premium_plus_cta_first_item_title',
      'configs[]=store_info/premium_plus_cta/premium_plus_cta_first_item/premium_plus_cta_first_item_category',
      'configs[]=store_info/premium_plus_cta/premium_plus_cta_first_item/premium_plus_cta_first_item_redirect',
      'configs[]=store_info/premium_plus_cta/premium_plus_cta_second_item/is_premium_plus_cta_second_enable',
      'configs[]=store_info/premium_plus_cta/premium_plus_cta_second_item/premium_plus_cta_second_item_image',
      'configs[]=store_info/premium_plus_cta/premium_plus_cta_second_item/premium_plus_cta_second_item_title',
      'configs[]=store_info/premium_plus_cta/premium_plus_cta_second_item/premium_plus_cta_second_item_category',
      'configs[]=store_info/premium_plus_cta/premium_plus_cta_second_item/premium_plus_cta_second_item_redirect',
      'configs[]=store_info/premium_plus_cta/premium_plus_cta_third_item/is_premium_plus_cta_third_enable',
      'configs[]=store_info/premium_plus_cta/premium_plus_cta_third_item/premium_plus_cta_third_item_image',
      'configs[]=store_info/premium_plus_cta/premium_plus_cta_third_item/premium_plus_cta_third_item_title',
      'configs[]=store_info/premium_plus_cta/premium_plus_cta_third_item/premium_plus_cta_third_item_category',
      'configs[]=store_info/premium_plus_cta/premium_plus_cta_third_item/premium_plus_cta_third_item_redirect',
      'configs[]=store_info/premium_plus_cta/premium_plus_cta_fourth_item/is_premium_plus_cta_fourth_enable',
      'configs[]=store_info/premium_plus_cta/premium_plus_cta_fourth_item/premium_plus_cta_fourth_item_image',
      'configs[]=store_info/premium_plus_cta/premium_plus_cta_fourth_item/premium_plus_cta_fourth_item_title',
      'configs[]=store_info/premium_plus_cta/premium_plus_cta_fourth_item/premium_plus_cta_fourth_item_category',
      'configs[]=store_info/premium_plus_cta/premium_plus_cta_fourth_item/premium_plus_cta_fourth_item_redirect'
    ];

    dispatch(getHomepagePremiumCTAConfigsStart());
    const {data} = await api.get(`${shopManagerApi}/store/configs?${params.join('&')}`);
    dispatch(getHomepagePremiumCTAConfigsSuccess(data));
  } catch (e) {
    dispatch(getHomepagePremiumCTAConfigsFailed(e));
  }
};
//TODO: to remove if won't be used anymore rel: https://dermpro.atlassian.net/browse/SM-2510
export const saveHomepageAdditionalBannersConfigsApi = async ({dispatch, configs}) => {
  try {
    dispatch(saveHomepageAdditionalBannersConfigsStart());
    const {data} = await api.patch(`${shopManagerApi}/store/configs`, {configs});
    dispatch(saveHomepageAdditionalBannersConfigsSuccess(data));
  } catch (e) {
    dispatch(saveHomepageAdditionalBannersConfigsFailed(e));
  }
};
export const saveHomepagePremiumCTAConfigsApi = async ({dispatch, configs}) => {
  try {
    dispatch(saveHomepagePremiumCTAConfigsStart());
    const {data} = await api.patch(`${shopManagerApi}/store/configs`, {configs});
    dispatch(saveHomepagePremiumCTAConfigsSuccess(data));
  } catch (e) {
    dispatch(saveHomepagePremiumCTAConfigsFailed(e));
  }
};

export const getHomepageBlogBlockConfigsApi = async ({dispatch}) => {
  try {
    const params = [
      'configs[]=store_info/premium_plus_blog/is_premium_plus_blog_enabled',
      'configs[]=store_info/premium_plus_blog/premium_plus_blog_title',
      'configs[]=store_info/premium_plus_blog/premium_plus_blog_url',
      'configs[]=store_info/premium_plus_blog/first_item_image',
      'configs[]=store_info/premium_plus_blog/first_item_text',
      'configs[]=store_info/premium_plus_blog/first_item_button_text',
      'configs[]=store_info/premium_plus_blog/first_item_button_link',
      'configs[]=store_info/premium_plus_blog/second_item_image',
      'configs[]=store_info/premium_plus_blog/second_item_text',
      'configs[]=store_info/premium_plus_blog/second_item_button_text',
      'configs[]=store_info/premium_plus_blog/second_item_button_link',
      'configs[]=store_info/premium_plus_blog/third_item_image',
      'configs[]=store_info/premium_plus_blog/third_item_text',
      'configs[]=store_info/premium_plus_blog/third_item_button_text',
      'configs[]=store_info/premium_plus_blog/third_item_button_link'
    ];

    dispatch(getHomepageBlogBlockConfigsStart());
    const {data} = await api.get(`${shopManagerApi}/store/configs?${params.join('&')}`);
    dispatch(getHomepageBlogBlockConfigsSuccess(data));
  } catch (e) {
    dispatch(getHomepageBlogBlockConfigsFailed(e));
  }
};

export const saveHomepageBlogBlockConfigsApi = async ({dispatch, configs}) => {
  try {
    dispatch(saveHomepageBlogBlockConfigsStart());
    const {data} = await api.patch(`${shopManagerApi}/store/configs`, {configs});
    dispatch(saveHomepageBlogBlockConfigsSuccess(data));
  } catch (e) {
    dispatch(saveHomepageBlogBlockConfigsFailed(e));
  }
};

export const getAppointmentBlockConfigsApi = async ({dispatch}) => {
  try {
    const params = [
      'configs[]=dermpro/design/appointment_block_mobile',
      'configs[]=store_info/request_an_appointment/is_request_an_appointment_enabled'
    ];

    dispatch(getAppointmentBlockConfigsStart());
    const {data} = await api.get(`${shopManagerApi}/store/configs?${params.join('&')}`);
    dispatch(getAppointmentBlockConfigsSuccess(data));
  } catch (e) {
    dispatch(getAppointmentBlockConfigsFailed(e));
  }
};

export const saveAppointmentBlockConfigsApi = async ({dispatch, configs}) => {
  try {
    dispatch(saveAppointmentBlockConfigsStart());
    const {data} = await api.patch(`${shopManagerApi}/store/configs`, {configs});
    dispatch(saveAppointmentBlockConfigsSuccess(data));
  } catch (e) {
    dispatch(saveAppointmentBlockConfigsFailed(e));
  }
};

export const getAboutUsPageConfigsApi = async ({dispatch}) => {
  try {
    const params = [
      'configs[]=store_info/about_us_page/is_about_us_page_enabled',
      'configs[]=store_info/about_us_page/is_top_banner_enabled',
      'configs[]=store_info/about_us_page/top_banner_image',
      'configs[]=store_info/about_us_page/is_main_content_enabled',
      'configs[]=store_info/about_us_page/is_provider_section_enabled',
      'configs[]=store_info/about_us_page/is_cta_full_enabled',
      'configs[]=store_info/about_us_page/is_cta_container_enabled',
      'configs[]=store_info/about_us_page/main_content_heading',
      'configs[]=store_info/about_us_page/main_content_text',
      'configs[]=store_info/about_us_page/provider_image',
      'configs[]=store_info/about_us_page/provider_main_heading',
      'configs[]=store_info/about_us_page/provider_secondary_heading',
      'configs[]=store_info/about_us_page/provider_content',
      'configs[]=store_info/about_us_page/cta_full_background_image',
      'configs[]=store_info/about_us_page/cta_full_content',
      'configs[]=store_info/about_us_page/cta_container_front_image',
      'configs[]=store_info/about_us_page/cta_container_back_image',
      'configs[]=store_info/about_us_page/cta_container_content'
    ];

    dispatch(getAboutUsPageConfigsStart());
    const {data} = await api.get(`${shopManagerApi}/store/configs?${params.join('&')}`);
    dispatch(getAboutUsPageConfigsSuccess(data));
  } catch (e) {
    dispatch(getAboutUsPageConfigsFailed(e));
  }
};

export const saveAboutUsPageConfigsApi = async ({dispatch, configs}) => {
  try {
    dispatch(saveAboutUsPageConfigsStart());
    const {data} = await api.patch(`${shopManagerApi}/store/configs`, {configs});
    dispatch(saveAboutUsPageConfigsSuccess(data));
  } catch (e) {
    dispatch(saveAboutUsPageConfigsFailed(e));
  }
};

export const getBeforeAfterGalleryConfigsApi = async ({dispatch}) => {
  try {
    const params = [
      'configs[]=beforeafter_gallery/general/enabled',
      'configs[]=beforeafter_gallery/general/url_key',
      'configs[]=beforeafter_gallery/general/page_title',
      'configs[]=beforeafter_gallery/general/description',
      'configs[]=beforeafter_gallery/general/meta_title',
      'configs[]=beforeafter_gallery/general/meta_description',
      'configs[]=beforeafter_gallery/general/meta_keywords',
      'configs[]=beforeafter_gallery/display/show_surgeon_filter',
      'configs[]=beforeafter_gallery/display/surgeon_filter_label',
      'configs[]=beforeafter_gallery/display/surgeon_filter_all_label',
      'configs[]=beforeafter_gallery/display/show_tag_filter',
      'configs[]=beforeafter_gallery/display/tag_filter_label',
      'configs[]=beforeafter_gallery/display/tag_filter_all_label',
      'configs[]=beforeafter_gallery/display/show_attributes',
      'configs[]=beforeafter_gallery/display/show_item_titles',
      'configs[]=beforeafter_gallery/display/before_label',
      'configs[]=beforeafter_gallery/display/after_label',
      'configs[]=beforeafter_gallery/tabs/tab1_enabled',
      'configs[]=beforeafter_gallery/tabs/tab1_label',
      'configs[]=beforeafter_gallery/tabs/tab1_image',
      'configs[]=beforeafter_gallery/tabs/tab2_enabled',
      'configs[]=beforeafter_gallery/tabs/tab2_label',
      'configs[]=beforeafter_gallery/tabs/tab2_image',
      'configs[]=beforeafter_gallery/tabs/tab3_enabled',
      'configs[]=beforeafter_gallery/tabs/tab3_label',
      'configs[]=beforeafter_gallery/tabs/tab3_image',
      'configs[]=beforeafter_gallery/tabs/tab4_enabled',
      'configs[]=beforeafter_gallery/tabs/tab4_label',
      'configs[]=beforeafter_gallery/tabs/tab4_image',
      'configs[]=beforeafter_gallery/tabs/tab5_enabled',
      'configs[]=beforeafter_gallery/tabs/tab5_label',
      'configs[]=beforeafter_gallery/tabs/tab5_image',
      'configs[]=beforeafter_gallery/tabs/tab6_enabled',
      'configs[]=beforeafter_gallery/tabs/tab6_label',
      'configs[]=beforeafter_gallery/tabs/tab6_image',
      'configs[]=beforeafter_gallery/data/surgeons',
      'configs[]=beforeafter_gallery/data/sections_tab1',
      'configs[]=beforeafter_gallery/data/sections_tab2',
      'configs[]=beforeafter_gallery/data/sections_tab3',
      'configs[]=beforeafter_gallery/data/sections_tab4',
      'configs[]=beforeafter_gallery/data/sections_tab5',
      'configs[]=beforeafter_gallery/data/sections_tab6'
    ];

    dispatch(getBeforeAfterGalleryConfigsStart());
    const {data} = await api.get(`${shopManagerApi}/store/configs?${params.join('&')}`);
    dispatch(getBeforeAfterGalleryConfigsSuccess(data));
  } catch (e) {
    dispatch(getBeforeAfterGalleryConfigsFailed(e));
  }
};

export const saveBeforeAfterGalleryConfigsApi = async ({dispatch, configs}) => {
  try {
    dispatch(saveBeforeAfterGalleryConfigsStart());
    const {data} = await api.patch(`${shopManagerApi}/store/configs`, {configs});
    dispatch(saveBeforeAfterGalleryConfigsSuccess(data));
  } catch (e) {
    dispatch(saveBeforeAfterGalleryConfigsFailed(e));
  }
};

export const saveHomepageAdditionalHeaderConfigsApi = async ({dispatch, configs}) => {
  try {
    dispatch(saveHomepageAdditionalHeaderConfigsStart());
    const {data} = await api.patch(`${shopManagerApi}/store/configs`, {configs});
    dispatch(saveHomepageAdditionalHeaderConfigsSuccess(data));
  } catch (e) {
    dispatch(saveHomepageAdditionalHeaderConfigsFailed(e));
  }
};

export const saveHomepageTestimonialsConfigsApi = async ({dispatch, configs}) => {
  try {
    dispatch(saveHomepageTestimonialsConfigsStart());
    const {data} = await api.patch(`${shopManagerApi}/store/configs`, {configs});
    dispatch(saveHomepageTestimonialsConfigsSuccess(data));
  } catch (e) {
    dispatch(saveHomepageTestimonialsConfigsFailed(e));
  }
};

export const saveHomepageRewardBlockConfigsApi = async ({dispatch, configs}) => {
  try {
    dispatch(saveHomepageRewardBlockConfigsStart());
    const {data} = await api.patch(`${shopManagerApi}/store/configs`, {configs});
    dispatch(saveHomepageRewardBlockConfigsSuccess(data));
  } catch (e) {
    dispatch(saveHomepageRewardBlockConfigsFailed(e));
  }
};

export const saveSocialMediaConfigsApi = async ({dispatch, configs}) => {
  try {
    dispatch(saveSocialMediaConfigsStart());
    const {data} = await api.patch(`${shopManagerApi}/store/configs`, {configs});
    dispatch(saveSocialMediaConfigsSuccess(data));
  } catch (e) {
    dispatch(saveSocialMediaConfigsFailed(e));
  }
};

export const updateStoreConfigsApi = async ({dispatch, configs}) => {
  try {
    dispatch(updateStoreConfigsStart());
    const {data} = await api.patch(`${shopManagerApi}/store/configs`, {configs});
    dispatch(updateStoreConfigsSuccess(data));
  } catch (e) {
    dispatch(updateStoreConfigsFailed(e));
  }
};

export const updateStoreSiteMapApi = async ({dispatch, isEnabled}) => {
  try {
    dispatch(updateStoreSiteMapStart());
    const {data} = await api.put(`${shopManagerApi}/store/cms-page/sitemap`, {identifier: 'rewardpointsinfo', use_in_html_sitemap: isEnabled, use_in_xml_sitemap: isEnabled, is_active: isEnabled});
    dispatch(updateStoreSiteMapSuccess(data));
  } catch (e) {
    dispatch(updateStoreSiteMapFailed(e));
  }
};

export const getStoreContactsConfigsApi = async ({dispatch}) => {
  try {
    const params = [
      'configs[]=general/store_information/name',
      'configs[]=trans_email/ident_general/email',
      'configs[]=general/store_information/phone',
      'configs[]=general/store_information/region_id',
      'configs[]=general/store_information/postcode',
      'configs[]=general/store_information/city',
      'configs[]=general/store_information/street_line1',
      'configs[]=general/store_information/street_line2'
    ];

    dispatch(getStoreContactsConfigsStart());
    const {data} = await api.get(`${shopManagerApi}/store/configs?${params.join('&')}`);
    dispatch(getStoreContactsConfigsSuccess(data));
  } catch (e) {
    dispatch(getStoreContactsConfigsFailed(e));
  }
};

export const saveStoreContactsConfigsApi = async ({dispatch, configs}) => {
  try {
    dispatch(saveStoreContactsConfigsStart());
    const {data} = await api.patch(`${shopManagerApi}/store/configs`, {configs});
    dispatch(saveStoreContactsConfigsSuccess(data));

    return true;
  } catch (e) {
    dispatch(saveStoreContactsConfigsFailed(e));

    return false;
  }
};

export const getStoreEmailsConfigsDataApi = async ({dispatch}) => {
  try {
    const params = [
      'configs[]=trans_email/ident_general/email',
      'configs[]=trans_email/ident_sales/email',
      'configs[]=trans_email/ident_support/email',
      'configs[]=request_access/general/send_to',
      'configs[]=webforms/email/email',
      'configs[]=dermpro_maxmind_config/general/email_address',
      'configs[]=subscriptions/subscription_confirm/copy_to',
      'configs[]=subscriptions/welcome_email/copy_to',
      'configs[]=subscriptions/subscription_available_product/copy_to',
      'configs[]=subscriptions/subscription_reactivation/copy_to',
      'configs[]=subscriptions/subscription_cancel/copy_to',
      'configs[]=subscriptions/subscription_skip/copy_to',
      'configs[]=subscriptions/billing_failed/copy_to',
      'configs[]=subscriptions/payment_failed/copy_to',
      'configs[]=subscriptions/billing_notice/copy_to',
      'configs[]=subscriptions/subscription_expiration/copy_to',
      'configs[]=subscriptions/subscription_suspension/copy_to',
      'configs[]=sales_email/order/copy_to',
      'configs[]=sales_email/order_comment/copy_to',
      'configs[]=sales_email/invoice/copy_to',
      'configs[]=sales_email/invoice_comment/copy_to',
      'configs[]=sales_email/shipment/copy_to',
      'configs[]=sales_email/shipment_comment/copy_to',
      'configs[]=sales_email/creditmemo/copy_to',
      'configs[]=sales_email/creditmemo_comment/copy_to',
      'configs[]=contact/email/recipient_email'
    ];

    dispatch(getStoreEmailsConfigsDataStart());
    const {data} = await api.get(`${shopManagerApi}/store/configs?${params.join('&')}`);
    dispatch(getStoreEmailsConfigsDataSuccess(data));
  } catch (e) {
    dispatch(getStoreEmailsConfigsDataFailed(e));
  }
};

export const saveStoreEmailsConfigsDataApi = async ({dispatch, configs, resetAppointmentBlockEmail = false}) => {
  try {
    dispatch(saveStoreEmailsConfigsDataStart());
    const {data} = await api.patch(`${shopManagerApi}/store/configs`, {configs});

    if (resetAppointmentBlockEmail) {
      await api.delete(`${shopManagerApi}/store/appointment-block/email`);
    }

    dispatch(saveStoreEmailsConfigsDataSuccess(data));

    return true;
  } catch (e) {
    dispatch(saveStoreEmailsConfigsDataFailed(e));

    return false;
  }
};

export const saveStoreNameApi = async ({dispatch, storeName}) => {
  try {
    dispatch(saveStoreNameStart());
    await api.put(`${shopManagerApi}/store/name`, {newStoreName: storeName});
    dispatch(saveStoreNameSuccess(storeName));

    return true;
  } catch (e) {
    dispatch(saveStoreNameFailed(e));

    return false;
  }
};

export const saveNotificationOptionsApi = async ({dispatch, emails, events, configs}) => {
  dispatch(saveNotificationOptionsStart());
  let failedNotification = [];
  let successedNotification = [];

  const emailsResult = await Promise.allSettled(emails.map((email) => {
    return api.post(`${shopManagerApi}/store/fue2/email`, {email});
  }));

  const eventsResult = await Promise.allSettled(events.map((event) => {
    return api.post(`${shopManagerApi}/store/fue2/event`, {event});
  }));

  try {
    const {data} = await api.patch(`${shopManagerApi}/store/configs`, {configs});
    successedNotification = [...successedNotification, data];
  } catch (e) {
    failedNotification = [...failedNotification, e];
  }

  emailsResult.forEach((result, idx) => {
    if (result.status == 'fulfilled') {
      successedNotification = [...successedNotification, result.value.data];
    }

    if (result.status == 'rejected') {
      failedNotification = [...failedNotification, emails[idx].name];
    }
  });

  eventsResult.forEach((result, idx) => {
    if (result.status == 'fulfilled') {
      successedNotification = [...successedNotification, result.value.data];
    }

    if (result.status == 'rejected') {
      failedNotification = [...failedNotification, events[idx].name];
    }
  });

  if (failedNotification.length === 0) {
    dispatch(saveNotificationOptionsSuccess(successedNotification));
  }

  if (successedNotification.length === 0) {
    dispatch(saveNotificationOptionsFailed(failedNotification));
  }

  if (failedNotification.length > 0 && successedNotification.length !== 0) {
    dispatch(saveNotificationOptionsWarning(failedNotification));
  }
};

export const getRewardBehaviorRulesAPI = async ({ dispatch }) => {
  try {
    dispatch(getRewardBehaviorRulesStart());
    const { data } = await api.get(`${shopManagerApi}/store/reward/behavior-rules`);
    dispatch(getRewardBehaviorRulesSuccess(data));
  } catch (e) {
    dispatch(getRewardBehaviorRulesFailed(e));
  }
};

export const updateRewardBehaviorRuleAPI = async ({ dispatch, rule }) => {
  try {
    dispatch(updateRewardBehaviorRuleStart());
    const { data } = await api.put(`${shopManagerApi}/store/reward/behavior-rule`, rule);
    dispatch(updateRewardBehaviorRuleSuccess(data));
    return true;
  } catch (e) {
    dispatch(updateRewardBehaviorRuleFailed(e));
    return false;
  }
};

export const getStoreBrandsApi = async ({ dispatch }) => {
  try {
    dispatch(getStoreBrandsStart());
    const { data } = await api.get(`${shopManagerApi}/store/brands`);
    dispatch(getStoreBrandsSuccess(data));
  } catch (e) {
    dispatch(getStoreBrandsFailed());
  }
};

export const getAllBrandsApi = async ({ dispatch }) => {
  try {
    dispatch(getAllBrandsStart());
    const { data } = await api.get(`${shopManagerApi}/store/all-brands`);
    dispatch(getAllBrandsSuccess(data));
  } catch (e) {
    dispatch(getAllBrandsFailed());
  }
};

export const getStoreEmailsApi = async ({ dispatch }) => {
  try {
    dispatch(getStoreEmailsStart());
    const { data } = await api.get(`${shopManagerApi}/store/settings/email`);
    dispatch(getStoreEmailsSuccess(data));
  } catch (e) {
    dispatch(getStoreEmailsFailed());
  }
};

export const getStoreProductExportApi = async ({ dispatch }) => {
  try {
    dispatch(getStoreProductsExportStart());
    const { data } = await api.get(`${shopManagerApi}/store/export/products`);
    dispatch(getStoreProductsExportSuccess(data));
  } catch (e) {
    dispatch(getStoreProductsExportFailed());
  }
};

export const getStoreProductsApi = async ({dispatch}) => {
  try {
    dispatch(getStoreProductsStart());
    const { data } = await api.get(`${shopManagerApi}/store/products?limit=1500`);
    dispatch(getStoreProductsSuccess(data));
  } catch (e) {
    dispatch(getStoreProductsFailed());
  }
};

export const getStoreCategoriesApi = async ({dispatch, checkStoreType = true, depth = 5}) => {
  try {
    const params = { depth, checkStoreType };

    dispatch(getStoreCategoriesStart());
    const { data } = await api.get(`${shopManagerApi}/store/categories${serialize(params)}`);
    dispatch(getStoreCategoriesSuccess(data));
  } catch (e) {
    dispatch(getStoreCategoriesFailed());
  }
};

export const getStoreCategoriesTreeApi = async ({dispatch}) => {
  try {
    dispatch(getStoreCategoriesTreeStart());
    const { data } = await api.get(`${shopManagerApi}/store/categories/tree?depth=5`);
    dispatch(getStoreCategoriesTreeSuccess(data));
  } catch (e) {
    dispatch(getStoreCategoriesTreeFailed());
  }
};

export const getStoreProductsByCategoryApi = async ({dispatch, categoryId}) => {
  try {
    dispatch(getCategoryProductsStart());
    const params = {};
    categoryId && (params.categoryId = categoryId);
    params.limit = 1000;

    const { data } = await api.get(`${shopManagerApi}/store/products${serialize(params)}`);
    dispatch(getCategoryProductsSuccess(data, categoryId));
  } catch (e) {
    dispatch(getCategoryProductsFailed());
  }
};

export const updateStoreProductsByCategoryApi = async ({dispatch, products}) => {
  try {
    dispatch(saveStoreProductsByCategoryStart());
    await api.patch(`${shopManagerApi}/store/categories/assign`, products);
    dispatch(saveStoreProductsByCategorySuccess());
  } catch (e) {
    dispatch(saveStoreProductsByCategoryFailed());
  }
};

// remove later, as not used anymore: https://dermpro.atlassian.net/browse/SM-2194
export const updateStoreProductCategoriesApi = async ({dispatch, categories}) => {
  try {
    dispatch(saveStoreProductCategoriesStart());
    const { data } = await api.patch(`${shopManagerApi}/store/categories/assign`, {...categories});
    dispatch(saveStoreProductCategoriesSuccess(data));
  } catch (e) {
    dispatch(saveStoreProductCategoriesFailed());
  }
};

export const createStoreCategoryApi = async ({dispatch, category}) => {
  try {
    dispatch(createStoreCategoryStart());
    const { data } = await api.post(`${shopManagerApi}/store/category`, category);
    getStoreCategoriesTreeApi({dispatch});
    dispatch(createStoreCategorySuccess(data));

    return data;
  } catch (e) {
    dispatch(createStoreCategoryFailed(e, category));
    return null;
  }
};

// remove later, as not used anymore: https://dermpro.atlassian.net/browse/SM-2194
export const addProductToStoreApi = async ({dispatch, product}) => {
  try {
    dispatch(addProductToStoreStart());
    const { data } = await api.post(`${shopManagerApi}/store/products`, {product});
    dispatch(addProductToStoreSuccess(product, data));
  } catch (error) {
    dispatch(addProductToStoreFailed(error, product));
  }
};

// remove later, as not used anymore: https://dermpro.atlassian.net/browse/SM-2194
// TODO: leave single API /store/products, or use queue to update product
export const editStoreProductApi = async ({dispatch, product, sku, showMessage = true}) => {
  try {
    dispatch(editStoreProductStart());
    const { data } = await api.patch(`${shopManagerApi}/store/products`, {product});
    dispatch(editStoreProductSuccess(data.result, sku, showMessage));
  } catch (e) {
    dispatch(editStoreProductFailed());
  }
};

// could be removed later, as we delete products in queue
export const deleteStoreProductApi = async ({dispatch, sku}) => {
  try {
    dispatch(deleteStoreProductStart());
    const { data } = await api.delete(`${shopManagerApi}/store/products/${sku}`);
    dispatch(deleteStoreProductSuccess(sku, data));
  } catch (e) {
    dispatch(deleteStoreProductFailed());
  }
};

// remove later, as not used anymore: https://dermpro.atlassian.net/browse/SM-2194
export const updateStoreCategoryStatusApi = ({dispatch, productIds}) => {
  try {
    dispatch(saveStoreProductCategoriesStart());
    const { data } = api.patch(`${shopManagerApi}/store/categories/status`, {productIds});
    dispatch(saveStoreProductCategoriesSuccess(data));
  } catch (e) {
    dispatch(saveStoreProductCategoriesFailed());
  }
};

// TODO: leave single API /store/products, or use queue to update product
export const editStoreProductUpSellApi = async ({dispatch, product}) => {
  try {
    dispatch(editStoreProductUpSellStart());
    const { data } = await api.patch(`${shopManagerApi}/store/products`, {product});
    dispatch(editStoreProductUpSellSuccess(data.result));
  } catch (e) {
    dispatch(editStoreProductUpSellFailed());
  }
};

// TODO: leave single API /store/products, or use queue to update product
export const removeStoreProductRelatedLinksAPI = async ({dispatch, product}) => {
  try {
    dispatch(removeStoreProductRelatedLinksStart());
    const { data } = await api.patch(`${shopManagerApi}/store/products`, {product});
    dispatch(removeStoreProductRelatedLinksSuccess(data.result));
  } catch (e) {
    dispatch(removeStoreProductRelatedLinksFailed());
  }
};

// TODO: leave single API /store/products, or use queue to update product
export const editStoreProductCrossSellApi = async ({dispatch, product}) => {
  try {
    dispatch(editStoreProductCrossSellStart());
    const { data } = await api.patch(`${shopManagerApi}/store/products`, {product});
    dispatch(editStoreProductCrossSellSuccess(data.result));
  } catch (e) {
    dispatch(editStoreProductCrossSellFailed());
  }
};

// TODO: leave single API /store/products, or use queue to update product
export const saveOneTimePurchaseProductAttrApi = async ({dispatch, product, sku}) => {
  try {
    dispatch(saveOneTimePurchaseProductAttrStart());
    const { data } = await api.patch(`${shopManagerApi}/store/products`, {product});
    dispatch(saveOneTimePurchaseProductAttrSuccess(data.result, sku));
  } catch (e) {
    dispatch(saveOneTimePurchaseProductAttrFailed());
  }
};

export const getEditableStoreProductApi = async ({dispatch, sku}) => {
  try {
    dispatch(getEditableStoreProductStart());
    const { data } = await api.get(`${shopManagerApi}/store/products/${sku}`);
    const subscription = await api.get(`${shopManagerApi}/store/product/subscription/${data.product.id}?sku=${sku}`);
    const customOptions = await api.get(`${shopManagerApi}/store/product/${sku}/custom-options`);
    dispatch(getEditableStoreProductSuccess(data));
    dispatch(getProductSubscriptionOptionsSuccess(subscription.data.items));
    dispatch(getProductCustomOptionsSuccess(customOptions.data));
  } catch (e) {
    dispatch(getEditableStoreProductFailed());
  }
};

export const getStoreTaxRatesApi = async ({dispatch, storeCode}) => {
  try {
    dispatch(getStoreTaxRatesStart());
    const { data } = await api.get(`${shopManagerApi}/store/tax-rules?code=${storeCode}`);
    const taxRatesIds = data.items[0]?.tax_rate_ids;
    const promises = taxRatesIds.map((id) => api.get(`${shopManagerApi}/store/tax-rate/${id}`));
    const results = await Promise.allSettled(promises);
    const taxRates = results.map((v) => v.value.data);
    dispatch(getStoreTaxRatesSuccess(taxRates, data.items[0]));
  } catch (e) {
    dispatch(getStoreTaxRatesFailed(e));
  }
};

export const createNewTaxRateApi = async ({dispatch, newTaxRate, taxRule}) => {
  try {
    dispatch(createNewTaxRateStart());
    const { data } = await api.patch(`${shopManagerApi}/store/tax-rate`, newTaxRate);
    const { id } = data;
    await api.patch(`${shopManagerApi}/store/tax-rule`, {...taxRule, tax_rate_ids: [...taxRule.tax_rate_ids, id]});
    dispatch(createNewTaxRateSuccess(data));
  } catch (e) {
    dispatch(createNewTaxRateFailed(e));
  }
};

export const editTaxRateApi = async ({dispatch, updatedEditTaxRate}) => {
  try {
    dispatch(editTaxRateStart());
    const {data} = await api.patch(`${shopManagerApi}/store/tax-rate`, updatedEditTaxRate);
    dispatch(editTaxRateSuccess(data));
  } catch (e) {
    dispatch(editTaxRateFailed(e));
  }
};

export const deleteTaxRateApi = async ({dispatch, idTaxRate, taxRule}) => {
  try {
    dispatch(deleteTaxRateStart());
    const availableTaxRateIds = taxRule.tax_rate_ids.filter((v) => v !== idTaxRate);
    await api.patch(`${shopManagerApi}/store/tax-rule`, {...taxRule, tax_rate_ids: availableTaxRateIds});
    await api.delete(`${shopManagerApi}/store/tax-rate/${idTaxRate}`);
    dispatch(deleteTaxRateSuccess(idTaxRate, {...taxRule, tax_rate_ids: availableTaxRateIds}));
  } catch (e) {
    dispatch(deleteTaxRateFailed());
  }
};

export const addSubscriptionOptionApi = async ({dispatch, subscriptions}) => {
  try {
    dispatch(addSubscriptionOptionStart());
    const subscriptionsResult = await Promise.allSettled(subscriptions.map((option) => api.patch(`${shopManagerApi}/store/product/subscription`, {interval: option})));
    dispatch(addProductSubscriptionOptionSuccess(subscriptionsResult));
  } catch (e) {
    dispatch(addSubscriptionOptionFailed());
  }
};

export const addCustomOptionApi = async ({dispatch, option}) => {
  try {
    dispatch(addCustomOptionStart());
    const { data } = await api.patch(`${shopManagerApi}/store/product/custom-option`, {option});
    dispatch(addCustomOptionSuccess(data));
  } catch (e) {
    dispatch(addCustomOptionFailed(e));
  }
};

export const editSubscriptionOptionApi = async ({ dispatch, subscriptionOptions }) => {
  try {
    dispatch(editProductSubscriptionOptionStart());

    let failedEditSubscriptionOptions = [];
    let successedEditSubscriptionOptions = [];

    const saveSubscriptionOptionsResult = await Promise.allSettled(
      subscriptionOptions.map((option) => {
        return api.patch(`${shopManagerApi}/store/product/subscription`, { interval: option });
      })
    );

    saveSubscriptionOptionsResult.forEach((result) => {
      if (result.status === 'fulfilled') {
        successedEditSubscriptionOptions = [...successedEditSubscriptionOptions, result.value.data];
      }

      if (result.status === 'rejected') {
        failedEditSubscriptionOptions = [...failedEditSubscriptionOptions, result.value.data];
      }
    });

    if (successedEditSubscriptionOptions.length) {
      dispatch(editProductSubscriptionOptionSuccess(successedEditSubscriptionOptions));
      return true;
    }

    if (failedEditSubscriptionOptions.length) {
      throw Error('Error happened while saving subscription options');
    }

    dispatch(showNotification('success', 'Successfully saved.'));
  } catch (e) {
    dispatch(editProductSubscriptionOptionFailed());
  }

  return false;
};

// TODO: leave single API /store/products, or use queue to update product
export const saveStoreProductSubscriptionAttrApi = async ({dispatch, product, sku, attributeCode}) => {
  try {
    dispatch(saveStoreProductSubscriptionAttrStart());
    const { data } = await api.patch(`${shopManagerApi}/store/products`, {product});
    dispatch(saveStoreProductSubscriptionAttrSuccess(data.result, sku, attributeCode));
  } catch (e) {
    dispatch(saveStoreProductSubscriptionAttrFailed(e));
  }
};

// TODO: leave single API /store/products, or use queue to update product
export const saveStoreProductMediaGalleryApi = async ({dispatch, product}) => {
  try {
    dispatch(saveStoreProductMediaGalleryStart());
    const { data } = await api.patch(`${shopManagerApi}/store/products`, {product});
    dispatch(saveStoreProductMediaGallerySuccess(data.result));
  } catch (e) {
    dispatch(saveStoreProductMediaGalleryFailed(e));
  }
};

export const editCustomOptionApi = async ({dispatch, option}) => {
  try {
    dispatch(editCustomOptionStart());
    const { data } = await api.patch(`${shopManagerApi}/store/product/custom-option`, {option});
    dispatch(editCustomOptionSuccess(data));
  } catch (e) {
    dispatch(editCustomOptionFailed(e));
  }
};

export const deleteCustomOptionValueApi = async ({dispatch, sku, option_type_id}) => {
  try {
    dispatch(deleteCustomOptionValueStart());
    const { data } = await api.delete(`${shopManagerApi}/store/product/custom-option/value/${option_type_id}`);

    if (data) {
      const { data } = await api.get(`${shopManagerApi}/store/product/${sku}/custom-options`);
      dispatch(deleteCustomOptionValueSuccess(data));
    }
  } catch (e) {
    dispatch(deleteCustomOptionValueFailed(e));
  }
};

export const deleteSubscriptionOptionApi = async ({dispatch, id}) => {
  try {
    dispatch(editProductSubscriptionOptionStart());
    const { data } = await api.delete(`${shopManagerApi}/store/product/subscription/${id}`);
    dispatch(deleteProductSubscriptionOptionSuccess(id, data));
  } catch (e) {
    dispatch(deleteProductSubscriptionOptionFailed());
  }
};

export const deleteOneTimeSubscriptionOptionApi = async ({dispatch, id}) => {
  try {
    dispatch(deleteOneTimeSubscriptionOptionStart());
    const { data } = await api.delete(`${shopManagerApi}/store/product/subscription/${id}`);
    dispatch(deleteOneTimeSubscriptionOptionSuccess(id, data));
  } catch (e) {
    dispatch(deleteOneTimeSubscriptionOptionFailed());
  }
};

export const deleteCustomOptionApi = async ({dispatch, id, sku}) => {
  try {
    dispatch(deleteCustomOptionStart());
    const { data } = await api.delete(`${shopManagerApi}/store/product/${sku}/custom-option/${id}`);
    dispatch(deleteCustomOptionSuccess(id, data));
  } catch (e) {
    dispatch(deleteCustomOptionFailed(e));
  }
};

export const getCustomOptionByIdApi = async ({dispatch, id, sku}) => {
  try {
    dispatch(getCustomOptionByIdStart());
    const { data } = await api.get(`${shopManagerApi}/store/product/${sku}/custom-option/${id}`);
    dispatch(getCustomOptionByIdSuccess(data));
  } catch (e) {
    dispatch(getCustomOptionByIdFailed(e));
  }
};

export const getFollowUpEmailsApi = async ({dispatch}) => {
  try {
    dispatch(getFollowUpEmailsStart());
    const campaigns = await api.get(`${shopManagerApi}/store/fue2/campaign/list`);
    const events = await api.get(`${shopManagerApi}/store/fue2/event/list`);
    const emails = await api.get(`${shopManagerApi}/store/fue2/email/list`);
    dispatch(getFollowUpEmailsSuccess(campaigns.data, events.data, emails.data));
  } catch (e) {
    dispatch(getFollowUpEmailsFailed());
  }
};

export const getStoreEarningRulesApi = async ({dispatch}) => {
  try {
    dispatch(getStoreEarningRulesStart());
    const { data } = await api.get(`${shopManagerApi}/store/reward/earning-rules`);
    dispatch(getStoreEarningRulesSuccess(data));
  } catch (e) {
    dispatch(getStoreEarningRulesFailed());
  }
};

export const getStoreSpendingRulesApi = async ({dispatch}) => {
  try {
    dispatch(getStoreSpendingRulesStart());
    const { data } = await api.get(`${shopManagerApi}/store/reward/spending-rules`);
    dispatch(getStoreSpendingRulesSuccess(data));
  } catch (e) {
    dispatch(getStoreSpendingRulesFailed());
  }
};

export const saveEarningRulesApi = async ({dispatch, rule}) => {
  try {
    dispatch(saveEarningRulesStart());
    const { data } = await api.patch(`${shopManagerApi}/store/reward/earning-rule`, rule);
    dispatch(saveEarningRulesSuccess(data));

    return true;
  } catch (e) {
    dispatch(saveEarningRulesFailed());

    return false;
  }
};

export const saveSpendingRulesApi = async ({dispatch, rule}) => {
  try {
    dispatch(saveSpendingRulesStart());
    const { data } = await api.patch(`${shopManagerApi}/store/reward/spending-rule`, rule);
    dispatch(saveSpendingRulesSuccess(data));

    return true;
  } catch (e) {
    dispatch(saveSpendingRulesFailed());

    return false;
  }
};

export const updateStoreEmailsApi = async ({dispatch, updateEmailsData}) => {
  try {
    dispatch(updateStoreEmailsStart());
    const { data } = await api.put(`${shopManagerApi}/store/settings/email`, updateEmailsData);
    dispatch(updateStoreEmailsSuccess(data));
    return true;
  } catch (e) {
    dispatch(updateStoreEmailsFailed(e));
    return false;
  }
};

export const getStoreRewardBehaviourRulesApi = async ({dispatch}) => {
  try {
    dispatch(getStoreRewardBehaviourRulesStart());
    const { data } = await api.get(`${shopManagerApi}/store/reward/behavior-rules`);
    dispatch(getStoreRewardBehaviourRulesSuccess(data));
  } catch (e) {
    dispatch(getStoreRewardBehaviourRulesFailed());
  }
};

export const saveStoreRewardBehaviourRulesApi = async ({dispatch, rule}) => {
  try {
    dispatch(saveStoreRewardBehaviourRulesStart());
    const { data } = await api.put(`${shopManagerApi}/store/reward/behavior-rule`, rule);
    dispatch(saveStoreRewardBehaviourRulesSuccess(data));

    return true;
  } catch (e) {
    dispatch(saveStoreRewardBehaviourRulesFailed());

    return false;
  }
};

export const saveStoreCategoryApi = async ({dispatch, category}) => {
  try {
    dispatch(saveStoreCategoryStart());
    const { data } = await api.put(`${shopManagerApi}/store/category`, category);
    dispatch(saveStoreCategorySuccess(data));
  } catch (e) {
    dispatch(saveStoreCategoryFailed(e, category));
  }
};

export const getFraudOrdersApi = async ({dispatch}) => {
  try {
    dispatch(getFraudOrdersStart());
    const { data } = await api.get(`${shopManagerApi}/store/order/fraud`);
    dispatch(getFraudOrdersSuccess(data));
  } catch (e) {
    dispatch(getFraudOrdersFailed(e));
  }
};

export const updateFraudOrderStatusApi = async ({dispatch, order}) => {
  try {
    dispatch(updateFraudOrderStatusStart());
    const { data } = await api.put(`${shopManagerApi}/store/order`, order);
    dispatch(updateFraudOrderStatusSuccess(data));
  } catch (e) {
    dispatch(updateFraudOrderStatusFailed(e));
  }
};

export const getStorePickupLocationsApi = async ({dispatch}) => {
  try {
    dispatch(getStorePickupLocationsStart());
    const { data } = await api.get(`${shopManagerApi}/store/pos/list`);
    dispatch(getStorePickupLocationsSuccess(data));
  } catch (e) {
    dispatch(getStorePickupLocationsFailed(e));
  }
};

export const addStorePickupLocationsApi = async ({dispatch, location, isAutoEnableStorePickup}) => {
  try {
    dispatch(addStorePickupLocationStart());
    const { data } = await api.post(`${shopManagerApi}/store/pos`, location);
    dispatch(addStorePickupLocationSuccess(data));

    if (isAutoEnableStorePickup) {
      const configs = [{
        path: 'carriers/pickupatstore/active',
        value: 1
      }];
      updateStorePickupConfigApi({dispatch, configs});
    }
  } catch (e) {
    dispatch(addStorePickupLocationFailed(e));
  }
};

export const updateStorePickupLocationsApi = async ({dispatch, location}) => {
  try {
    dispatch(updateStorePickupLocationStart());
    const { data } = await api.post(`${shopManagerApi}/store/pos`, location);
    dispatch(updateStorePickupLocationSuccess(data));
  } catch (e) {
    dispatch(updateStorePickupLocationFailed(e));
  }
};

export const deleteStorePickupLocationApi = async ({dispatch, id}) => {
  try {
    dispatch(deleteStorePickupLocationStart());
    const { data } = await api.delete(`${shopManagerApi}/store/pos/${id}`);
    dispatch(deleteStorePickupLocationSuccess(id, data));
  } catch (e) {
    dispatch(deleteStorePickupLocationFailed(e));
  }
};

export const getStorePickupConfigApi = async ({dispatch}) => {
  try {
    dispatch(getStorePickupConfigStart());
    const { data } = await api.get(`${shopManagerApi}/store/configs?configs[]=carriers/pickupatstore/active`);
    dispatch(getStorePickupConfigSuccess(data));
  } catch (e) {
    dispatch(getStorePickupConfigFailed(e));
  }
};

export const updateStorePickupConfigApi = async ({dispatch, configs}) => {
  try {
    dispatch(updateStorePickupConfigStart());
    const {data} = await api.patch(`${shopManagerApi}/store/configs`, {configs});
    dispatch(updateStorePickupConfigSuccess(data));
  } catch (e) {
    dispatch(updateStorePickupConfigFailed(e));
  }
};

export const getFBTLinksApi = async ({dispatch, sku}) => {
  try {
    dispatch(getFBTLinksStart());
    const { data } = await api.get(`${shopManagerApi}/store/product/${sku}/frequently-bought`);
    dispatch(getFBTLinksSuccess(data));
  } catch (e) {
    dispatch(getFBTLinksFailed(e));
  }
};

export const saveFBTLinksApi = async ({dispatch, sku, selectedSkus}) => {
  dispatch(saveFBTLinksStart());
  let failedSaveFBTLinks = [];
  let successedSaveFBTLinks = [];
  let saveFRTLinks = [];

  const saveFBTLinksResult = await Promise.allSettled(selectedSkus.map((item, idx) => {
    const data = {
      entity: {
        linked_product_sku: item,
        position: idx
      }
    };

    saveFRTLinks = [...saveFRTLinks, data.entity];

    return api.put(`${shopManagerApi}/store/product/${sku}/frequently-bought/links`, data);
  }));

  saveFBTLinksResult.forEach((result, idx) => {
    if (result.status == 'fulfilled') {
      successedSaveFBTLinks = [...successedSaveFBTLinks, result.value.data];
    }

    if (result.status == 'rejected') {
      failedSaveFBTLinks = [...failedSaveFBTLinks, selectedSkus[idx].name];
    }
  });

  if (failedSaveFBTLinks.length === 0) {
    dispatch(saveFBTLinksSuccess(saveFRTLinks));
  }

  if (successedSaveFBTLinks.length === 0) {
    dispatch(saveFBTLinksFailed(failedSaveFBTLinks));
  }

  if (failedSaveFBTLinks.length > 0 && successedSaveFBTLinks.length !== 0) {
    dispatch(saveFBTLinksWarning(failedSaveFBTLinks));
  }
};

export const removeFBTLinkApi = async ({dispatch, sku, linkedProductSku}) => {
  try {
    dispatch(removeFBTLinkStart());
    const { data } = await api.delete(`${shopManagerApi}/store/product/${sku}/frequently-bought/${linkedProductSku}`);
    dispatch(removeFBTLinkSuccess(linkedProductSku, data));
  } catch (e) {
    dispatch(removeFBTLinkFailed(e));
  }
};

export const getCouponListApi = async ({dispatch}) => {
  try {
    dispatch(getCouponListStart());
    const { data } = await api.get(`${shopManagerApi}/store/coupon/list?pageSize=`);
    dispatch(getCouponListSuccess(data));
  } catch (e) {
    dispatch(getCouponListFailed(e));
  }
};

export const generateCouponForEmailApi = async ({dispatch, couponData}) => {
  try {
    dispatch(generateCouponForEmailStart());
    const { data } = await api.post(`${shopManagerApi}/store/coupon/generate-for-email`, couponData);
    dispatch(generateCouponForEmailSuccess(data));
  } catch (e) {
    dispatch(generateCouponForEmailFailed(e));
  }
};

export const generateCouponRuleApi = async ({dispatch, couponRule}) => {
  try {
    dispatch(generateCouponRuleStart());
    const { data } = await api.patch(`${shopManagerApi}/store/coupon/rule`, couponRule);
    dispatch(generateCouponRuleSuccess(data));
  } catch (e) {
    dispatch(generateCouponRuleFailed(e));
  }
};


//Combined API methods
export const createCouponRuleCombinedApi = async ({
  dispatch,
  filterConditions,
  couponRule,
  coupon_code
}) => {
  try {
    const params = convertToSearchCriteria({
      searchConditions: [],
      filterConditions,
      pageSize: '1',
      currentPage: '1',
      sortField: 'created_at',
      sortDirection: 'DESC'
    });

    dispatch(createCouponRuleCombinedStart());

    const { data } = await api.get(`${shopManagerApi}/store/sales-rules-coupons?${params}`);

    if (data.coupons.items.length) {
      throw new Error('Coupon Code already exist');
    } else {
      const couponRuleData = await api.post(`${shopManagerApi}/store/sales-rules`, couponRule);
      const { rule_id } = couponRuleData.data.salesRule;
      const couponCodeWithRuleId = {...coupon_code, rule_id};

      await api.post(`${shopManagerApi}/store/sales-rules-coupons`, couponCodeWithRuleId);
    }

    dispatch(createCouponRuleCombinedSuccess());
    return true;
  } catch (e) {
    dispatch(createCouponRuleCombinedFailed(e));
    return false;
  }
};

export const updateCouponRuleCombinedApi = async ({dispatch, couponRuleWithCode }) => {
  try {
    const { coupon_code, ...couponRule } = couponRuleWithCode;
    const {coupon_id} = coupon_code;

    dispatch(updateCouponRuleCombinedStart());
    const params = convertToSearchCriteria({
      searchConditions: [],
      filterConditions: [
        {
          field: 'code',
          value: coupon_code.code,
          conditionType: 'eq'
        }
      ],
      pageSize: '1',
      currentPage: '1',
      sortField: 'created_at',
      sortDirection: 'DESC'
    });

    const { data } = await api.get(`${shopManagerApi}/store/sales-rules-coupons?${params}`);
    const [magentoCoupone] = data.coupons.items;
    let salesRuleCouponData;

    if (magentoCoupone && magentoCoupone.rule_id !== couponRule.rule_id) {
      throw new Error('Coupon Code already exist');
    } else if (!magentoCoupone) {
      const response =  await api.put(`${shopManagerApi}/store/sales-rules-coupons/${coupon_id}`, {
        coupon_id,
        rule_id: couponRule.rule_id,
        code: coupon_code.code,
        is_primary: true,
        type: 0,
      });
      salesRuleCouponData = response.data.salesRuleCoupon;
    }

    const { data: {salesRule} } = await api.put(`${shopManagerApi}/store/sales-rules/${couponRule.rule_id}`, couponRule);

    const updatedCouponRule = {
      ...salesRule,
      coupon_code: salesRuleCouponData || coupon_code,
    };

    dispatch(updateCouponRuleCombinedSuccess(updatedCouponRule));

    return true;
  } catch (e) {
    dispatch(updateCouponRuleCombinedFailed(e));

    return false;
  }
};

export const updateCouponRuleIfNoCodeExists = async ({dispatch, couponRuleWithCode }) => {
  try {
    dispatch(updateCouponRuleCombinedStart());
    const { coupon_code: { code }, coupon_type, ...couponRule } = couponRuleWithCode;

    let updatedRule;

    if (code) {
      const params = convertToSearchCriteria({
        searchConditions: [],
        filterConditions: [
          {
            field: 'code',
            value: code,
            conditionType: 'eq'
          }
        ],
        pageSize: 1,
        currentPage: 1,
        sortField: 'created_at',
        sortDirection: 'DESC'
      });
      const { data } = await api.get(`${shopManagerApi}/store/sales-rules-coupons?${params}`);
      const [magentoCoupone] = data.coupons.items;

      if (magentoCoupone) {
        throw new Error('Coupon Code already exist');
      } else {
        const { data: {salesRule} } = await api.put(`${shopManagerApi}/store/sales-rules/${couponRule.rule_id}`, {...couponRule, coupon_type: 'SPECIFIC_COUPON'});

        const response = await api.post(`${shopManagerApi}/store/sales-rules-coupons`, {
          rule_id: salesRule.rule_id,
          code,
          is_primary: true,
          type: 0,
        });

        updatedRule = {
          ...salesRule,
          coupon_code: response.data.salesRuleCoupon,
        };
      }
    } else {
      const { data: {salesRule} } = await api.put(`${shopManagerApi}/store/sales-rules/${couponRule.rule_id}`, couponRule);
      updatedRule = salesRule;
    }

    dispatch(updateCouponRuleCombinedSuccess(updatedRule));

    return true;
  } catch (e) {
    dispatch(updateCouponRuleCombinedFailed(e));

    return false;
  }
};

export const getCouponRulesApi = async ({
  dispatch,
  filterConditions,
  currentPage,
  pageSize,
  sortDirection,
  sortField,
  searchConditions
}) => {
  try {
    const params = convertToSearchCriteria({
      searchConditions,
      filterConditions,
      pageSize,
      currentPage,
      sortField,
      sortDirection
    });

    dispatch(getCouponRulesStart());
    const { data: rulesData } = await api.get(`${shopManagerApi}/store/sales-rules?${params}`);

    const ruleIds = rulesData.salesRules.items.map((rule) => rule.rule_id).join(',');

    const codeParams = convertToSearchCriteria({
      searchConditions: [],
      filterConditions: [
        {
          field: 'rule_id',
          value: ruleIds,
          conditionType: 'in'
        }
      ],
      pageSize: '100',
      currentPage: '1',
      sortField: 'coupon_id',
      sortDirection: 'DESC'
    });
    const { data: couponData } = await api.get(`${shopManagerApi}/store/sales-rules-coupons?${codeParams}`);
    dispatch(getCouponRulesSuccess(rulesData, couponData));
  } catch (e) {
    dispatch(getCouponRulesFailed(e));
  }
};

export const getCouponCodeApi = async ({dispatch, rule_id}) => {
  try {
    const params = convertToSearchCriteria({
      searchConditions: [],
      filterConditions: [
        {
          field: 'rule_id',
          value: rule_id,
          conditionType: 'eq'
        }
      ],
      pageSize: '100',
      currentPage: '1',
      sortField: 'created_at',
      sortDirection: 'DESC'
    });

    dispatch(getCouponCodeStart());
    const { data } = await api.get(`${shopManagerApi}/store/sales-rules-coupons?${params}`);
    dispatch(getCouponCodeSuccess(data, rule_id));
  } catch (e) {
    dispatch(getCouponCodeFailed(e));
  }
};

export const deleteCouponRuleApi = async (dispatch, id) => {
  try {
    dispatch(deleteCouponRuleStart());
    await api.delete(`${shopManagerApi}/store/sales-rules/${id}`);
    dispatch(deleteCouponRuleSuccess(id));
  } catch (e) {
    dispatch(deleteCouponRuleFailed(e));
  }
};

export const getCMSPagesApi = async ({ dispatch }, onlyActive = true) => {
  try {
    dispatch(getCMSPagesStart());
    const { data } = await api.get(`${shopManagerApi}/store/cms-page/list?onlyActive=${onlyActive}`);
    dispatch(getCMSPagesSuccess(data));
  } catch (e) {
    dispatch(getCMSPagesFailed(e));
  }
};

export const updateCMSPageApi = async ({dispatch, pageData}) => {
  try {
    dispatch(updateCMSPageStart());
    const { data } = await api.put(`${shopManagerApi}/store/cms-page`, pageData);
    dispatch(updateCMSPageSuccess(data));
  } catch (e) {
    dispatch(updateCMSPageFailed(e));
  }
};

export const getStoreLogosApi = async ({dispatch}) => {
  try {
    dispatch(getStoreLogosStart());
    const { data } = await api.get(`${shopManagerApi}/store/theme`);
    dispatch(getStoreLogosSuccess(data));
  } catch (e) {
    dispatch(getStoreLogosFailed(e));
  }
};

export const uploadStoreLogoApi = async ({dispatch, key, logo, customPath, fileName}) => {
  try {
    dispatch(uploadStoreLogoStart());
    const { data } = await api.post(
      `${shopManagerApi}/store/image`,
      {base64: logo, custom_path: customPath, file_name: fileName}
    );
    dispatch(uploadStoreLogoSuccess(data, key));

    return data;
  } catch (e) {
    dispatch(uploadStoreLogoFailed(e));

    return false;
  }
};

export const getConfigsLogosApi = async ({dispatch, apiUrl}) => {
  const params = [
    'configs[]=mpgiftcard/template/logo',
    'configs[]=sales/identity/logo',
    'configs[]=sales/identity/logo_html'
  ];

  try {
    dispatch(getConfigsLogosStart());
    const { data } = await api.get(`${shopManagerApi}/store/configs?${params.join('&')}`);
    dispatch(getConfigsLogosSuccess(data, apiUrl));
  } catch (e) {
    dispatch(getConfigsLogosFaild(e));
  }
};

export const updateAllLogosApi = async ({dispatch, storeConfiguration, configData}) => {
  try {
    dispatch(updateAllLogosStart());
    const storeLogosData = await api.post(`${shopManagerApi}/store/theme`, storeConfiguration);
    dispatch(setStoreLogoSuccess(storeLogosData.data));
    const configsLogos = await api.patch(`${shopManagerApi}/store/configs`, {configs: configData.config});
    dispatch(setConfigLogosSuccess(configsLogos.data));
    dispatch(updateAllLogosSuccess());
  } catch (error) {
    dispatch(updateAllLogosFailed());
  }
};

export const createMerchantAccount = async ({ dispatch, merchant, templateId }) => {
  try {
    dispatch(createMerchantAccountStart());
    const { data } = await api.post(`${shopManagerApi}/copilote/merchant`, { merchant, templateId });
    dispatch(createMerchantAccountSuccess(data));
  } catch (e) {
    dispatch(createMerchantAccountFailed(e));
  }
};

export const getStoreConfigsSummaryApi = async ({ dispatch, refresh }) => {
  try {
    dispatch(getStoreConfigsSummaryStart());
    const params = {};
    refresh && (params.refresh = refresh);
    const { data } = await api.get(`${shopManagerApi}/store/config-summary${serialize(params)}`);
    dispatch(getStoreConfigsSummarySuccess(data));
  } catch (e) {
    dispatch(getStoreConfigsSummaryFailed(e));
  }
};

export const getStoreEmailsStyleApi = async ({ dispatch }) => {
  try {
    dispatch(getStoreEmailsStyleStart());
    const { data } = await api.get(`${shopManagerApi}/store/configs?configs[]=asset_manager/email_image_style/email_style`);
    dispatch(getStoreEmailsStyleSuccess(data));
  } catch (e) {
    dispatch(getStoreEmailsStyleFailed(e));
  }
};

export const getCustomOptionsPriceTypesApi = async ({ dispatch, sku }) => {
  try {
    dispatch(getCustomOptionsPriceTypesStart());
    const { data } = await api.get(`${shopManagerApi}/store/product/${sku}/custom-option-price-types`);
    dispatch(getCustomOptionsPriceTypesSuccess(data));
  } catch (e) {
    dispatch(getCustomOptionsPriceTypesFailed(e));
  }
};

export const saveCustomOptionsPriceTypesApi = async ({ dispatch, sku, priceTypes}) => {
  try {
    dispatch(saveCustomOptionsPriceTypesStart());
    const { data } = await api.patch(`${shopManagerApi}/store/product/${sku}/custom-option-price-types`, {types: priceTypes});
    dispatch(saveCustomOptionsPriceTypesSuccess(data));
  } catch (e) {
    dispatch(saveCustomOptionsPriceTypesFailed(e));
  }
};

export const getHomepageBannerGroupApi = async ({ dispatch, identifier}) => {
  try {
    dispatch(getHomepageBannerGroupStart());
    const params = {};
    identifier && (params.identifier = identifier);
    const { data } = await api.get(`${shopManagerApi}/store/homepage-banner/groups${serialize(params)}`);
    dispatch(getHomepageBannerGroupSuccess(data));
  } catch (e) {
    dispatch(getHomepageBannerGroupFailed(e));
  }
};

export const saveBannerSlideApi = async ({dispatch, slideData}) => {
  try {
    dispatch(saveBannerSlideStart());
    const { data } = await api.post(`${shopManagerApi}/store/homepage-banner`, slideData);
    dispatch(saveBannerSlideSuccess(data));
  } catch (e) {
    dispatch(saveBannerSlideFailed(e));
  }
};

export const deleteBannerSlideApi = async ({dispatch, id}) => {
  try {
    dispatch(deleteBannerSlideStart());
    await api.delete(`${shopManagerApi}/store/homepage-banner/${id}`);
    dispatch(deleteBannerSlideSuccess(id));
  } catch (e) {
    dispatch(deleteBannerSlideFailed(e));
  }
};

export const addNewBannerSlideApi = async ({dispatch, slideData}) => {
  try {
    dispatch(addNewBannerSlideStart());
    const { data } = await api.post(`${shopManagerApi}/store/homepage-banner`, slideData);
    dispatch(addNewBannerSlideSuccess(data));
  } catch (e) {
    dispatch(addNewBannerSlideFailed(e));
  }
};

export const getReferralRules = async ({dispatch}) => {
  try {
    dispatch(getReferralRulesStart());
    const { data } = await api.get(`${shopManagerApi}/store/reward/referral-rules`);
    dispatch(getReferralRulesSuccess(data.items));
  } catch (e) {
    dispatch(getReferralRulesFailed());
  }
};

export const saveReferralRule = async ({dispatch, referralRuleData}) => {
  try {
    dispatch(saveReferralRuleStart());
    const { data } = await api.patch(`${shopManagerApi}/store/reward/referral-rule`, referralRuleData);
    dispatch(saveReferralRuleSuccess(data));

    return true;
  } catch (e) {
    dispatch(saveReferralRuleFaild(e));

    return false;
  }
};

export const deleteReferralRule = async ({dispatch, referralRuleId}) => {
  try {
    dispatch(deleteReferralRuleStart());
    const { data } = await api.delete(`${shopManagerApi}/store/reward/referral-rule/${referralRuleId}`);
    dispatch(deleteReferralRuleSuccess(data));

    return true;
  } catch (e) {
    dispatch(deleteReferralRuleFailed(e));

    return false;
  }
};

export const getCurrentStoreStylesApi = async ({dispatch}) => {
  try {
    const params = [
      'configs[]=theme_design/colors/color_primary',
      'configs[]=theme_design/colors/color_secondry',
      'configs[]=theme_design/colors/color_additional',
      'configs[]=theme_design/colors/color_primary_text_color',
      'configs[]=theme_design/defined_fonts/google_fonts_string',
      'configs[]=theme_design/defined_fonts/font_stacks_string',
      'configs[]=theme_design/font/body_font_size',
      'configs[]=theme_design/font/body_font_family',
      'configs[]=theme_design/font_fallback/body_font_stack',
      'configs[]=theme_design/font/heading1_font_family',
      'configs[]=theme_design/font/heading1_font_color',
      'configs[]=theme_design/font/heading1_font_size',
      'configs[]=theme_design/font/heading1_font_weight',
      'configs[]=theme_design/font/heading1_text_transform',
      'configs[]=theme_design/font/heading1_line_height',
      'configs[]=theme_design/font/heading2_font_family',
      'configs[]=theme_design/font/heading2_font_color',
      'configs[]=theme_design/font/heading2_font_size',
      'configs[]=theme_design/font/heading2_font_weight',
      'configs[]=theme_design/font/heading2_text_transform',
      'configs[]=theme_design/font/heading2_line_height',
      'configs[]=theme_design/font/heading3_font_family',
      'configs[]=theme_design/font/heading3_font_color',
      'configs[]=theme_design/font/heading3_font_size',
      'configs[]=theme_design/font/heading3_font_weight',
      'configs[]=theme_design/font/heading3_text_transform',
      'configs[]=theme_design/font/heading3_line_height',
      'configs[]=theme_design/font/heading4_font_family',
      'configs[]=theme_design/font/heading4_font_color',
      'configs[]=theme_design/font/heading4_font_size',
      'configs[]=theme_design/font/heading4_font_weight',
      'configs[]=theme_design/font/heading4_text_transform',
      'configs[]=theme_design/font/heading4_line_height',
      'configs[]=theme_design/font/heading5_font_family',
      'configs[]=theme_design/font/heading5_font_color',
      'configs[]=theme_design/font/heading5_font_size',
      'configs[]=theme_design/font/heading5_font_weight',
      'configs[]=theme_design/font/heading5_text_transform',
      'configs[]=theme_design/font/heading5_line_height',
      'configs[]=theme_design/font/heading6_font_family',
      'configs[]=theme_design/font/heading6_font_color',
      'configs[]=theme_design/font/heading6_font_size',
      'configs[]=theme_design/font/heading6_font_weight',
      'configs[]=theme_design/font/heading6_text_transform',
      'configs[]=theme_design/font/heading6_line_height',
      'configs[]=theme_design/font/paragraph_font_family',
      'configs[]=theme_design/font/paragraph_font_color',
      'configs[]=theme_design/font/paragraph_font_size',
      'configs[]=theme_design/font/paragraph_line_height',
      'configs[]=theme_design/font/list_style_type',
      'configs[]=theme_design/colors/link_color',
      'configs[]=theme_design/colors/link_hover_color',
      'configs[]=theme_design/colors/link_text_decoration',
      'configs[]=theme_design/colors/link_text_decoration_hover',
      'configs[]=theme_design/colors/link_font_weight',
      'configs[]=theme_design/colors/button_bg_color',
      'configs[]=theme_design/colors/button_color',
      'configs[]=theme_design/colors/button_hover_bg_color',
      'configs[]=theme_design/colors/button_hover_color',
      'configs[]=theme_design/colors/button_font_size',
      'configs[]=theme_design/colors/button_font_family',
      'configs[]=theme_design/colors/button_text_transform',
      'configs[]=theme_design/colors/button_font_weight',
      'configs[]=theme_design/colors/button_font_style',
      'configs[]=theme_design/colors/button_border_radius',
      'configs[]=theme_design/colors/button_border',
      'configs[]=theme_design/colors/button_border_hover',
      'configs[]=theme_design/colors/label_new_bg_color',
      'configs[]=theme_design/colors/label_new_color',
      'configs[]=theme_design/colors/label_sale_bg_color',
      'configs[]=theme_design/colors/label_sale_color',
      'configs[]=theme_design/header/header_bg_color',
      'configs[]=theme_design/header/top_border_color',
      'configs[]=theme_design/header_primary/text_font_size',
      'configs[]=theme_design/header_primary/text_color',
      'configs[]=theme_design/header_primary/text_link_color',
      'configs[]=theme_design/header_primary/text_link_hover_color',
      'configs[]=theme_design/header_primary/button_color',
      'configs[]=theme_design/header_primary/button_hover_color',
      'configs[]=theme_design/header_primary/button_background',
      'configs[]=theme_design/header_primary/button_hover_background',
      'configs[]=theme_design/m_header/tab_item_bg_color',
      'configs[]=theme_design/m_header/tab_item_color',
      'configs[]=theme_design/m_header/counter_bg_color',
      'configs[]=theme_design/m_header/counter_bg_active_color',
      'configs[]=theme_design/m_header/sub_menu_bg',
      'configs[]=theme_design/m_header/sub_menu_color',
      'configs[]=theme_design/m_header/sub_menu_font_family',
      'configs[]=theme_design/m_header/sub_menu_text_transform',
      'configs[]=theme_design/m_header/sub_menu_font_size',
      'configs[]=theme_design/m_header/sub_menu_font_weight'
    ];
    const params2 = [
      'configs[]=theme_design/nav/outer_menu_bg_color',
      'configs[]=theme_design/nav/color',
      'configs[]=theme_design/nav/hover_bg_color',
      'configs[]=theme_design/nav/hover_color',
      'configs[]=theme_design/nav/font_family',
      'configs[]=theme_design/nav/text_transform',
      'configs[]=theme_design/nav/font_size',
      'configs[]=theme_design/nav/font_weight',
      'configs[]=theme_design/nav/text_decoration',
      'configs[]=theme_design/nav/text_decoration_hover',
      'configs[]=theme_design/nav/letter_spacing',
      'configs[]=theme_design/nav/is_menu_item_underline_effect',
      'configs[]=theme_design/nav/underline_height',
      'configs[]=theme_design/nav/underline_color',
      'configs[]=theme_design/nav/dropdown_bg_color',
      'configs[]=theme_design/nav/dropdown_item_hover_bg_color',
      'configs[]=theme_design/nav/dropdown_link_color',
      'configs[]=theme_design/nav/dropdown_link_hover_color',
      'configs[]=theme_design/nav/dropdown_font_family',
      'configs[]=theme_design/nav/dropdown_text_transform',
      'configs[]=theme_design/nav/dropdown_font_size',
      'configs[]=theme_design/nav/dropdown_font_weight',
      'configs[]=theme_design/nav/dropdown_text_decoration',
      'configs[]=theme_design/nav/dropdown_text_decoration_hover',
      'configs[]=theme_design/nav/dropdown_item_is_border_bottom',
      'configs[]=theme_design/nav/dropdown_item_border_bottom',
      'configs[]=theme_design/footer/bg_color',
      'configs[]=theme_design/footer/color',
      'configs[]=theme_design/footer/link_color',
      'configs[]=theme_design/footer/link_hover_color',
      'configs[]=theme_design/footer/border_top',
      'configs[]=theme_design/footer/button_bg_color',
      'configs[]=theme_design/footer/button_color',
      'configs[]=theme_design/footer/button_hover_bg_color',
      'configs[]=theme_design/footer/button_hover_color',
      'configs[]=theme_design/footer_bottom/color',
      'configs[]=theme_design/footer_bottom/link_color',
      'configs[]=theme_design/footer_bottom/link_hover_color',
      'configs[]=theme_design/footer_bottom/bg_color',
      'configs[]=theme_design/footer_tagline/bg_color',
      'configs[]=theme_design/footer_tagline/color',
      'configs[]=theme_design/footer_tagline/font_size',
      'configs[]=theme_design/footer_tagline/font_weight',
      'configs[]=theme_design/colors/price_color',
      'configs[]=theme_design/colors/price_font_size',
      'configs[]=theme_design/colors/price_font_weight',
      'configs[]=theme_design/colors/rating_active_color',
      'configs[]=theme_design/colors/product_name_color',
      'configs[]=theme_design/colors/product_name_font_size',
      'configs[]=theme_design/colors/product_name_font_weight',
      'configs[]=theme_design/colors/product_name_text_transform',
      'configs[]=theme_design/colors/product_name_text_align',
      'configs[]=theme_design/category/category_promo_font_family',
      'configs[]=theme_design/category/category_promo_font_size',
      'configs[]=theme_design/category/category_promo_font_weight',
      'configs[]=theme_design/category/category_promo_line_height',
      'configs[]=theme_design/category/category_promo_padding',
      'configs[]=theme_design/category/category_promo_bg_color',
      'configs[]=theme_design/category/category_promo_color',
      'configs[]=theme_design/product_page/product_promo_font_family',
      'configs[]=theme_design/product_page/product_promo_font_size',
      'configs[]=theme_design/product_page/product_promo_font_weight',
      'configs[]=theme_design/product_page/product_promo_line_height',
      'configs[]=theme_design/product_page/product_promo_padding',
      'configs[]=theme_design/product_page/product_promo_bg_color',
      'configs[]=theme_design/product_page/product_promo_color',
      'configs[]=theme_design/product_page/product_tabs_bg_color',
      'configs[]=theme_design/product_page/product_tabs_color',
      'configs[]=theme_design/product_page/product_tabs_bg_color_active',
      'configs[]=theme_design/product_page/product_tabs_color_active',
      'configs[]=theme_design/main/login_promo_bg_color',
      'configs[]=theme_design/main/login_promo_color',
      'configs[]=theme_design/main/login_promo_title_font_size',
      'configs[]=theme_design/main/login_promo_title_font_weight',
      'configs[]=theme_design/main/login_promo_font_family',
      'configs[]=theme_design/main/login_promo_desc_font_size',
      'configs[]=theme_design/main/login_promo_text_transform',
      'configs[]=theme_design/cta/cta_mask_bg',
      'configs[]=theme_design/cta/cta_mask_title_color',
      'configs[]=theme_design/cta/cta_mask_link_color',
      'configs[]=theme_design/cta/cta_mask_link_color_hover',
      'configs[]=theme_design/cta/cta_mask_button_bg',
      'configs[]=theme_design/cta/cta_mask_button_color',
      'configs[]=theme_design/cta/cta_mask_button_bg_hover',
      'configs[]=theme_design/cta/cta_mask_button_color_hover',
      'configs[]=theme_design/cta/button_border',
      'configs[]=theme_design/cta/button_border_hover',
      'configs[]=theme_design/cta/cta_vertical_title_color',
      'configs[]=theme_design/cta/cta_horizontal_top_title_color',
      'configs[]=theme_design/cta/cta_horizontal_bottom_title_color',
      'configs[]=theme_design/cta/cta_title_font_weight'
    ];

    const params3 = [
      'configs[]=theme_design/premium_plus_homepage/premium_plus_cta_title_color',
      'configs[]=theme_design/premium_plus_homepage/premium_plus_cta_title_font_size',
      'configs[]=theme_design/premium_plus_homepage/premium_plus_cta_title_transform',
      'configs[]=theme_design/premium_plus_homepage/premium_plus_cta_title_font_weight',
      'configs[]=theme_design/premium_plus_homepage/premium_plus_cta_title_font_style',
      'configs[]=theme_design/premium_plus_homepage/premium_plus_cta_item_bg',
      'configs[]=theme_design/premium_plus_homepage/premium_plus_cta_text_color',
      'configs[]=theme_design/premium_plus_homepage/premium_plus_cta_text_font_size',
      'configs[]=theme_design/premium_plus_homepage/premium_plus_cta_text_transform',
      'configs[]=theme_design/premium_plus_homepage/premium_plus_cta_text_font_weight',
      'configs[]=theme_design/premium_plus_homepage/premium_plus_cta_text_font_style',
      'configs[]=theme_design/premium_plus_homepage/testimonials_bg',
      'configs[]=theme_design/premium_plus_homepage/testimonials_block_text_color',
      'configs[]=theme_design/premium_plus_homepage/testimonials_block_text_font_size',
      'configs[]=theme_design/premium_plus_homepage/testimonials_block_text_transform',
      'configs[]=theme_design/premium_plus_homepage/testimonials_block_text_font_weight',
      'configs[]=theme_design/premium_plus_homepage/testimonials_block_text_font_style',
      'configs[]=theme_design/premium_plus_homepage/testimonials_block_rating_color',
      'configs[]=theme_design/premium_plus_homepage/testimonials_block_rating_bg_color',
      'configs[]=theme_design/premium_plus_homepage/testimonials_block_author_color',
      'configs[]=theme_design/premium_plus_homepage/testimonials_block_author_font_size',
      'configs[]=theme_design/premium_plus_homepage/testimonials_block_author_font_weight',
      'configs[]=theme_design/premium_plus_homepage/testimonials_block_author_transform',
      'configs[]=theme_design/premium_plus_homepage/testimonials_block_author_font_style',
      'configs[]=theme_design/premium_plus_homepage/blog_block_bg',
      'configs[]=theme_design/premium_plus_homepage/blog_block_main_heading_color',
      'configs[]=theme_design/premium_plus_homepage/blog_block_main_heading_font_size',
      'configs[]=theme_design/premium_plus_homepage/blog_block_text_color',
      'configs[]=theme_design/premium_plus_homepage/blog_block_text_font_size',
      'configs[]=theme_design/premium_plus_homepage/blog_block_button_bg',
      'configs[]=theme_design/premium_plus_homepage/blog_block_button_color',
      'configs[]=theme_design/premium_plus_homepage/blog_block_button_border_color',
      'configs[]=theme_design/premium_plus_homepage/blog_block_button_bg_hover',
      'configs[]=theme_design/premium_plus_homepage/blog_block_button_color_hover',
      'configs[]=theme_design/premium_plus_homepage/instagram_block_mask_bg',
      'configs[]=theme_design/premium_plus_homepage/instagram_block_main_heading_color',
      'configs[]=theme_design/premium_plus_homepage/instagram_block_main_heading_font_size',
      'configs[]=theme_design/premium_plus_homepage/instagram_block_button_bg',
      'configs[]=theme_design/premium_plus_homepage/instagram_block_button_color',
      'configs[]=theme_design/premium_plus_homepage/instagram_block_button_border_color',
      'configs[]=theme_design/premium_plus_homepage/instagram_block_button_bg_hover',
      'configs[]=theme_design/premium_plus_homepage/instagram_block_button_color_hover',
      'configs[]=theme_design/premium_plus_homepage/additional_header_bg',
      'configs[]=theme_design/premium_plus_homepage/additional_header_text_color',
      'configs[]=theme_design/premium_plus_homepage/additional_header_text_font_size',
      'configs[]=theme_design/premium_plus_homepage/additional_header_icon_color',
      'configs[]=theme_design/premium_plus_homepage/additional_header_text_color_hover',
      'configs[]=theme_design/premium_plus_homepage/additional_header_icon_color_hover',
      'configs[]=theme_design/premium_plus_footer/text_transform',
      'configs[]=theme_design/premium_plus_footer/newsletter_bg_color',
      'configs[]=theme_design/premium_plus_footer/font_size',
      'configs[]=theme_design/premium_plus_footer/font_weight'
    ];

    dispatch(getCurrentStoreStylesStart());
    const response = await api.get(`${shopManagerApi}/store/configs?${params.join('&')}`);
    const response2 = await api.get(`${shopManagerApi}/store/configs?${params2.join('&')}`);
    const response3 = await api.get(`${shopManagerApi}/store/configs?${params3.join('&')}`);
    dispatch(getCurrentStoreStylesSuccess([
      ...response.data.config,
      ...response2.data.config,
      ...response3.data.config
    ]));
  } catch (e) {
    dispatch(getCurrentStoreStylesFailed(e));
  }
};

export const getDefaultStoreStylesApi = async ({dispatch}) => {
  try {
    dispatch(getDefaultStoreStylesStart());
    const {data} = await api.get(`${shopManagerApi}/store/default-theme`);
    dispatch(getDefaultStoreStylesSuccess(data));
  } catch (e) {
    dispatch(getDefaultStoreStylesFailed(e));
  }
};

export const saveStoreStylesApi = async ({dispatch, configs, isSaveAsDefault}) => {
  try {
    dispatch(saveStoreStylesStart());
    const {data} = await api.patch(`${shopManagerApi}/store/configs`, {configs});

    if (isSaveAsDefault) {
      await api.patch(`${shopManagerApi}/store/default-theme`, {configs});
    }

    dispatch(saveStoreStylesSuccess(data, isSaveAsDefault));
  } catch (e) {
    dispatch(saveStoreStylesFailed(e));
  }
};

export const getStoreTaxClassesApi = async ({dispatch}) => {
  try {
    dispatch(getStoreTaxClassesStart());
    const {data} = await api.get(`${shopManagerApi}/store/tax-classes`);
    dispatch(getStoreTaxClassesSuccess(data));
  } catch (e) {
    dispatch(getStoreTaxClassesFailed(e));
  }
};

export const sendDNSConfigurationsApi = async ({dispatch, values}) => {
  try {
    dispatch(sendDNSConfigurationsStart());
    const {data} = await api.post(`${shopManagerApi}/dns/help-request`, values);
    dispatch(sendDNSConfigurationsSuccess(data));
  } catch (e) {
    dispatch(sendDNSConfigurationsFailed(e));
  }
};

export const verifyDNSConfigurationsApi = async ({dispatch}) => {
  try {
    dispatch(verifyDNSConfigurationsStart());
    const {data} = await api.post(`${shopManagerApi}/dns/verify`);
    dispatch(verifyDNSConfigurationsSuccess(data));
  } catch (e) {
    dispatch(verifyDNSConfigurationsFailed(e));
  }
};

export const getBookNowButtonConfigApi = async ({dispatch}) => {
  const params = [
    'configs[]=theme_design/header_primary/is_cta_left_link_enabled',
    'configs[]=theme_design/header_primary/cta_left_link_title',
    'configs[]=theme_design/header_primary/is_cta_left_link_external',
    'configs[]=theme_design/header_primary/cta_left_link'
  ];

  try {
    dispatch(getBookNowButtonConfigsStart());
    const {data} = await api.get(`${shopManagerApi}/store/configs?${params.join('&')}`);
    dispatch(getBookNowButtonConfigsSuccess(data));
  } catch (e) {
    dispatch(getBookNowButtonConfigFailed);
  }
};

export const saveBookNowButtonConfigApi = async ({dispatch, configs}) => {
  try {
    dispatch(saveBookNowButtonConfigStart());
    const {data} = await api.patch(`${shopManagerApi}/store/configs`, {configs});
    dispatch(saveBookNowButtonConfigSuccess(data));
  } catch (e) {
    dispatch(saveBookNowButtonConfigFailed(e));
  }
};

export const getAppointmentButtonConfigsApi = async ({dispatch}) => {
  const params = [
    'configs[]=theme_design/header_primary/is_cta_right_link_enabled',
    'configs[]=theme_design/header_primary/cta_right_link_title',
    'configs[]=theme_design/header_primary/is_cta_right_link_external',
    'configs[]=theme_design/header_primary/cta_right_link'
  ];

  try {
    dispatch(getAppointmentButtonConfigsStart());
    const {data} = await api.get(`${shopManagerApi}/store/configs?${params.join('&')}`);
    dispatch(getAppointmentButtonConfigsSuccess(data));
  } catch (e) {
    dispatch(getAppointmentButtonConfigsFailed(e));
  }
};

export const saveAppointmentButtonConfigsApi = async ({dispatch, configs}) => {
  try {
    dispatch(saveAppointmentButtonConfigsStart());
    const {data} = await api.patch(`${shopManagerApi}/store/configs`, {configs});
    dispatch(saveAppointmentButtonConfigsSuccess(data));
  } catch (e) {
    dispatch(saveAppointmentButtonConfigFailed(e));
  }
};

export const getAllTasksFromQueueApi = async ({dispatch, storeViewCode}) => {
  try {
    dispatch(getAllTasksFromQueueStart());
    const params = new URLSearchParams({storeViewCode});
    const {data} = await api.get(`${shopManagerApi}/queue?${params}`);
    dispatch(getAllTasksFromQueueSuccess(data, storeViewCode));
  } catch (e) {
    dispatch(getAllTasksFromQueueFailed(e));
  }
};

export const addTasksToQueueApi = async ({dispatch, tasks}) => {
  try {
    dispatch(addTasksToQueueStart());
    const {data} = await api.post(`${shopManagerApi}/queue`, tasks);
    dispatch(addTasksToQueueSuccess(data));
  } catch (e) {
    dispatch(addTasksToQueueFailed(e));
  }
};

export const removeTaskFromQueueApi = async ({dispatch, task}) => {
  try {
    dispatch(removeTaskFromQueueStart());
    const {data} = await api.delete(`${shopManagerApi}/queue/${task._id}`);
    dispatch(removeTaskFromQueueSuccess(data));
  } catch (e) {
    dispatch(removeTaskFromQueueFailed(e));
  }
};

export const addPatientCertificationApi = async ({dispatch, option}) => {
  try {
    dispatch(addPatientCertificationStart());
    const {data} = await api.patch(`${shopManagerApi}/store/product/custom-option`, {option});
    dispatch(addPatientCertificationSuccess(data));
  } catch (e) {
    dispatch(addPatientCertificationFailed(e));
  }
};

export const editPatientCertificationsApi = async ({dispatch, option}) => {
  try {
    dispatch(editPatientCertificationsStart());
    const {data} = await api.patch(`${shopManagerApi}/store/product/custom-option`, {option});
    dispatch(editPatientCertificationsSuccess(data));
  } catch (e) {
    dispatch(editPatientCertificationsFailed(e));
  }
};

export const setPatientCertificationApi = async ({dispatch, product, certification, enabled}) => {
  try {
    dispatch(setPatientCertificationStart());
    const {data} = await api.patch(`${shopManagerApi}/store/product/${product.sku}/certification`, {
      certification,
      enabled
    });
    dispatch(setPatientCertificationSuccess(data));
  } catch (e) {
    dispatch(setPatientCertificationFailed(e));
  }
};

export const deletePatientCertificationsApi = async ({dispatch, product, disabledOption}) => {
  try {
    dispatch(deletePatientCertificationStart());
    await api.delete(`${shopManagerApi}/store/product/${product.sku}/custom-option/${disabledOption.option_id}`);
    dispatch(deletePatientCertificationSuccess(disabledOption));
  } catch (e) {
    dispatch(deletePatientCertificationsFailed(e));
  }
};

export const getRequestAccessConfigsApi = async ({dispatch}) => {
  const params = [
    'configs[]=request_access/general/is_enabled'
  ];

  try {
    dispatch(getRequestAccessConfigsStart());
    const {data} = await api.get(`${shopManagerApi}/store/configs?${params.join('&')}`);
    dispatch(getRequestAccessConfigsSuccess(data));
  } catch (e) {
    dispatch(getRequestAccessConfigsFailed(e));
  }
};

export const getDepositConfigApi = async ({dispatch}) => {
  const params = [
    'configs[]=deposit_payment/general/enable'
  ];

  try {
    dispatch(getDepositConfigStart());
    const {data} = await api.get(`${shopManagerApi}/store/configs?${params.join('&')}`);
    dispatch(getDepositConfigSuccess(data));
  } catch (e) {
    dispatch(getDepositConfigFailed(e));
  }
};
